import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from '../redux/actions/index';
import io from 'socket.io-client';
import QRCode from "qrcode.react";
import ScreenShare from "../component/ScreenShare";
import { v4 as uuidv4 } from 'uuid';
import Constants, { SHOPPING_DOMAIN, SOCKET_IO_PATH, SOCKET_RTC_URL, SOCKET_URL } from "../utils/Constants";
import Avatar from 'react-avatar';
import AppLoader from "../utils/AppLoader";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import NoEffect from '../assets/img/no_effect.svg'
import {
    getVideoDevicesSummary,
    getUserMediaForCameraSwitch,
    shouldOfferCameraSwitch,
    SWITCH_CAMERA_NOT_SUPPORTED_MSG,
} from '../utils/videoInputDevices';
import {
    ensurePatientMediaPermission,
    patientMediaPermissionMessage,
    ensureMediaDevicesApi,
} from '../utils/patientMediaPermission';
import PatientCallSession from '../utils/patientCallSession';
import { releaseWebRtcCallMedia } from '../utils/releaseWebRtcCallMedia';
import {
    persistVendorDefaultVideoFlags,
    readDefaultVideoOnNurse,
    resolveInitialLocalVideoMute,
} from '../utils/vendorDefaultVideo';
import cameraSignalPolicy from '../utils/cameraSignalPolicy';
import { savePatientRoomEntry, getPatientRoomEntry } from '../utils/patientRoomAccess';
import { isPatientLeaveAllowed } from '../utils/patientBackGuard';
// import patientRingTone from '../assets/sound/Discord.mp3';
import patientRingTone from '../assets/audio/sample1.wav';
import ackEnglishOnTheWay from '../assets/audio/ack/ack_on_the_way_en.mp3';
import ackEnglishReach30 from '../assets/audio/ack/ack_reach_30_sec_en.mp3';
import ackEnglishReach1Min from '../assets/audio/ack/ack_reach_1_min_en.mp3';
import ackTamilOnTheWay from '../assets/audio/ack/ack_on_the_way_ta.mp3';
import ackTamilReach30 from '../assets/audio/ack/ack_reach_30_sec_ta.mp3';
import ackTamilReach1Min from '../assets/audio/ack/ack_reach_1_min_ta.mp3';

/** Indian English (co.in) + Tamil Nadu spoken Tamil clips */
const ACK_ENGLISH_AUDIO_BY_KEY = {
    on_the_way: ackEnglishOnTheWay,
    reach_30_sec: ackEnglishReach30,
    reach_1_min: ackEnglishReach1Min,
};
const ACK_TAMIL_AUDIO_BY_KEY = {
    on_the_way: ackTamilOnTheWay,
    reach_30_sec: ackTamilReach30,
    reach_1_min: ackTamilReach1Min,
};

// RTCMultiConnection (public/js) expects global `io`
if (typeof window !== 'undefined' && typeof window.io === 'undefined') {
    window.io = io;
}

let canvas = null;
let width = 320;
let height = 0;
var backgroundInterval
var segmentationStream = true
let timmerId
let endCallListing = true
class Verification extends Component {
    constructor(props) {
        super(props);
        // Prefer room/vendor flags in localStorage; fall back to login Vendor for agent web.
        try {
            const vendorFromToken = props?.getLoginDetails?.tokenDetails?.userDetails?.VendorAgent?.Vendor
                || props?.getLoginDetails?.vendorTokenDetails?.userDetails?.Vendor
                || props?.getLoginDetails?.tokenDetails?.userDetails?.Vendor;
            if (vendorFromToken && (vendorFromToken.defaultVideoOnNurse != null || vendorFromToken.defaultVideoOnPatient != null)) {
                persistVendorDefaultVideoFlags(vendorFromToken);
            }
        } catch (_e) {
            /* ignore */
        }
        const initialVideoMute = resolveInitialLocalVideoMute(!!props.isCustomer);
        this.state = {
            roomId: '',
            isChatOpened: false,
            chat: [],
            message: '',
            isMute: false,
            isVideoMute: initialVideoMute,
            unreadMessageCount: 0,
            isZoom: false,
            isScreenShared: false,
            isCaptureButton: false,
            verificationImage: "",
            screenRoomId: "",
            isScreenView: false,
            video: [],
            microphone: [],
            speaker: [],
            chatList: [],
            avatarmain: false,
            customerName: '',
            agentName: '',
            connnectionMessage: {},
            checkIsConnected: false,
            isLoading: false,
            isMobileDevice: false,
            isVrBackgroundIcon: false,
            isVirtualBackground: false,
            isVirtualBackgroundIMG: '',
            virtualBackgroundSelectId: 0,
            virtualBackgroundImages: [],
            vbOption: 1,
            srm_ip_room: null,
            isSrmIpAgent: 0,
            ip_head_redirect_model: false,
            /** Local WebRTC stream is live; stays true after remote stream (unlike checkIsConnected). */
            localStreamStarted: false,
            canSwitchCamera: false,
            videoInputDeviceIds: [],
            activeVideoDeviceIndex: 0,
            isSwitchingCamera: false,
            /** Customer call UX: ringing (waiting agent) → connecting (agent attended) → connected */
            callPhase: 'ringing',
            callDurationDisplay: '00:00:00',
            showCallDuration: false,
            isReconnectingStream: false,
            showEndCallConfirm: false,
            // Patient: own video full page, nurse in small PiP (CSS .video-swapped)
            isVideoSwapped: !!props.isCustomer,
            mediaPermissionBlocked: false,
            /** Nurse quick-ack while still ringing (patient reassurance) */
            nurseAckMessage: '',
            nurseAckAgentName: '',
        }
        this.canvasRef = React.createRef();
        this._callDurationInterval = null;
        this._callDurationStart = 0;
        this._maxCallDurationTimer = null;
        this._reconnectRetryTimer = null;
        this._reconnectInterval = null;
        this._reconnectDeadlineTimer = null;
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        this._headRedirectStarted = false;
        this._headRedirectInProgress = false;
        this._wardRedirectStarted = false;
        this._wardRedirectInProgress = false;
        this._wardEscalationTimer = null;
        this._patientTotalTimer = null;
        this._isEndingCall = false;
        this._blockedSessionStart = false;
        this._mediaPermissionBlocked = false;
        this._patientRingAudio = null;
        this._patientRingStarted = false;
        this._patientAckReceived = false;
        this._ackFeedbackStarted = false;
        this._feedbackNavDone = false;
        this._ackVoicePlaying = false;
        this._pendingEndAfterAckVoice = false;
        this._ackLockedVoice = null;
        this._pendingRemoteCamOff = false;
        this._remoteCamOffFromSignal = false;
        this._remoteMediaStream = null;
        this._remoteCamOffPoll = null;
        /** Nurse app starts camera-off — don't show black until first unmute */
        this._nurseCamConfirmedOn = readDefaultVideoOnNurse();
        this._patientCamAnnounceTimers = [];
    }
    startPatientRingTone = () => {
        if (!this.props.isCustomer || this._isEndingCall) {
            return;
        }
        try {
            if (!this._patientRingAudio) {
                this._patientRingAudio = new Audio(patientRingTone);
                this._patientRingAudio.loop = true;
                this._patientRingAudio.preload = 'auto';
                this._patientRingAudio.volume = 0.7;
            }
            if (this._patientRingStarted && !this._patientRingAudio.paused) {
                return;
            }
            this._patientRingAudio.currentTime = 0;
            const playPromise = this._patientRingAudio.play();
            if (playPromise && typeof playPromise.then === 'function') {
                playPromise.then(() => {
                    this._patientRingStarted = true;
                }).catch(() => {
                    // Autoplay may be blocked until a gesture; retry on next overlay update.
                    this._patientRingStarted = false;
                });
            } else {
                this._patientRingStarted = true;
            }
        } catch (e) {
            this._patientRingStarted = false;
        }
    };

    stopPatientRingTone = () => {
        try {
            if (this._patientRingAudio) {
                this._patientRingAudio.pause();
                this._patientRingAudio.currentTime = 0;
            }
        } catch (e) {
            /* ignore */
        }
        this._patientRingStarted = false;
    };

    stopNurseAckSpeech = (force = false) => {
        // While ack voice-over is playing, do not cancel (nurse may already have ended).
        if (this._ackVoicePlaying && !force) {
            return;
        }
        try {
            if (typeof window !== 'undefined' && window.speechSynthesis) {
                window.speechSynthesis.cancel();
            }
        } catch (e) {
            /* ignore */
        }
        try {
            if (this._ackTamilAudio) {
                this._ackTamilAudio.pause();
                this._ackTamilAudio.currentTime = 0;
                this._ackTamilAudio = null;
            }
        } catch (e) {
            /* ignore */
        }
        try {
            if (this._ackEnglishAudio) {
                this._ackEnglishAudio.pause();
                this._ackEnglishAudio.currentTime = 0;
                this._ackEnglishAudio = null;
            }
        } catch (e) {
            /* ignore */
        }
    };

    playAckAudioClip = (srcMap, messageKey, audioRefKey) =>
        new Promise((resolve) => {
            try {
                const src = srcMap[String(messageKey || '').trim()];
                if (!src) {
                    resolve({ ok: false });
                    return;
                }
                if (this[audioRefKey]) {
                    try {
                        this[audioRefKey].pause();
                    } catch (e) { /* ignore */ }
                }
                const audio = new Audio(src);
                this[audioRefKey] = audio;
                audio.preload = 'auto';
                audio.volume = 1;
                let settled = false;
                const done = (ok) => {
                    if (settled) return;
                    settled = true;
                    if (this[audioRefKey] === audio) {
                        this[audioRefKey] = null;
                    }
                    resolve({ ok: !!ok });
                };
                audio.onended = () => done(true);
                audio.onerror = () => done(false);
                setTimeout(() => done(false), 20000);
                const playPromise = audio.play();
                if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.catch(() => done(false));
                }
            } catch (e) {
                resolve({ ok: false });
            }
        });

    /** Indian English (Tamil Nadu / India accent) pre-recorded clip */
    playAckEnglishAudio = (messageKey) =>
        this.playAckAudioClip(ACK_ENGLISH_AUDIO_BY_KEY, messageKey, '_ackEnglishAudio');

    /** Tamil Nadu spoken Tamil pre-recorded clip */
    playAckTamilAudio = (messageKey) =>
        this.playAckAudioClip(ACK_TAMIL_AUDIO_BY_KEY, messageKey, '_ackTamilAudio');

    /**
     * Common default English voice for "Hi + nurse name" (natural, not accent-tuned).
     */
    pickCommonEnglishVoice = () => {
        try {
            if (typeof window === 'undefined' || !window.speechSynthesis) {
                return null;
            }
            const voices = window.speechSynthesis.getVoices() || [];
            if (!voices.length) {
                return null;
            }
            const scoreVoice = (voice) => {
                const name = String(voice?.name || '').toLowerCase();
                const lang = String(voice?.lang || '').toLowerCase();
                if (!lang.startsWith('en')) {
                    return -1;
                }
                let score = 10;
                // Prefer widely available OS defaults
                if (lang === 'en-us' || lang.startsWith('en-us')) score += 40;
                else if (lang === 'en-gb' || lang.startsWith('en-gb')) score += 30;
                else if (lang.startsWith('en')) score += 15;
                const commonHints = [
                    'google us english', 'google uk english',
                    'microsoft zira', 'microsoft david', 'microsoft mark',
                    'samantha', 'alex', 'daniel', 'karen', 'moira',
                ];
                if (commonHints.some((h) => name.includes(h))) score += 35;
                // Avoid specialty / regional voices that often misread Indian names
                if (name.includes('heera') || name.includes('ravi') || name.includes('neerja')
                    || name.includes('veena') || name.includes('raveena') || lang.startsWith('en-in')) {
                    score -= 50;
                }
                return score;
            };

            let best = null;
            let bestScore = -1;
            voices.forEach((voice) => {
                const score = scoreVoice(voice);
                if (score > bestScore) {
                    bestScore = score;
                    best = voice;
                }
            });
            return bestScore >= 10 ? best : null;
        } catch (e) {
            return null;
        }
    };

    /** Fallback Tamil / English voice for MP3 failure paths only. */
    pickFemaleIndianVoice = (langPrefix = 'en') => {
        try {
            if (typeof window === 'undefined' || !window.speechSynthesis) {
                return null;
            }
            const voices = window.speechSynthesis.getVoices() || [];
            if (!voices.length) {
                return null;
            }
            const want = String(langPrefix || 'en').toLowerCase();
            if (want === 'ta') {
                return voices.find((v) => String(v.lang || '').toLowerCase().startsWith('ta')) || null;
            }
            return this.pickCommonEnglishVoice()
                || voices.find((v) => String(v.lang || '').toLowerCase().startsWith('en'))
                || null;
        } catch (e) {
            return null;
        }
    };

    waitMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    /**
     * Speak one line. Returns { ok } — ok=false if TTS errored / never started
     * so Tamil can fall back instead of ending the call early.
     */
    speakUtterance = (text, { lang = 'en-US', voice = null, pitch = 1, rate = 1 } = {}) =>
        new Promise((resolve) => {
            try {
                if (!text || typeof window === 'undefined' || !window.speechSynthesis) {
                    resolve({ ok: false });
                    return;
                }
                try {
                    window.speechSynthesis.resume();
                } catch (e) {
                    /* ignore */
                }
                const utterance = new window.SpeechSynthesisUtterance(String(text));
                utterance.lang = lang;
                utterance.rate = rate;
                utterance.pitch = pitch;
                utterance.volume = 1;
                // Only attach voice when it matches the requested language family.
                // Forcing en-IN voice onto ta-IN text makes Chrome fire onerror immediately.
                if (voice) {
                    const vLang = String(voice.lang || '').toLowerCase();
                    const want = String(lang || '').toLowerCase().slice(0, 2);
                    if (!want || vLang.startsWith(want)) {
                        utterance.voice = voice;
                    }
                }
                let settled = false;
                let started = false;
                const done = (ok) => {
                    if (settled) return;
                    settled = true;
                    resolve({ ok: !!ok });
                };
                utterance.onstart = () => {
                    started = true;
                };
                utterance.onend = () => done(started);
                utterance.onerror = () => done(false);
                const safetyMs = Math.min(20000, Math.max(6000, String(text).length * 140));
                setTimeout(() => done(started), safetyMs);
                window.speechSynthesis.speak(utterance);
            } catch (e) {
                resolve({ ok: false });
            }
        });

    /**
     * Hi I am + nurse name (common browser voice) → English clip → Tamil clip → feedback.
     */
    speakNurseAckBilingual = async ({
        spokenName,
        spokenTextEn,
        spokenTextTa,
        spokenTextTaRoman,
        messageKey,
        onFinished,
    } = {}) => {
        if (!this.props.isCustomer) {
            if (typeof onFinished === 'function') onFinished();
            return;
        }
        this._ackVoicePlaying = true;
        this._pendingEndAfterAckVoice = true;
        try {
            this.stopNurseAckSpeech(true);
            await this.waitMs(280);

            const hasSpeech = typeof window !== 'undefined'
                && window.speechSynthesis
                && typeof window.SpeechSynthesisUtterance !== 'undefined';

            if (hasSpeech) {
                const waitForVoices = () => new Promise((resolve) => {
                    const existing = window.speechSynthesis.getVoices() || [];
                    if (existing.length) {
                        resolve();
                        return;
                    }
                    const onVoices = () => {
                        try {
                            window.speechSynthesis.removeEventListener('voiceschanged', onVoices);
                        } catch (e) { /* ignore */ }
                        resolve();
                    };
                    window.speechSynthesis.addEventListener('voiceschanged', onVoices);
                    setTimeout(() => {
                        try {
                            window.speechSynthesis.removeEventListener('voiceschanged', onVoices);
                        } catch (e) { /* ignore */ }
                        resolve();
                    }, 900);
                });
                await waitForVoices();
            }

            const commonVoice = hasSpeech ? this.pickCommonEnglishVoice() : null;
            this._ackLockedVoice = commonVoice;
            const name = String(spokenName || 'Nurse').trim() || 'Nurse';
            const greeting = `Hi I am ${name}`;

            // 1) Hi I am + nurse name — common default English voice
            if (hasSpeech) {
                await this.speakUtterance(greeting, {
                    lang: commonVoice?.lang || 'en-US',
                    voice: commonVoice,
                    pitch: 1,
                    rate: 1,
                });
                await this.waitMs(280);
            }

            // 2) English message MP3
            const enAudio = await this.playAckEnglishAudio(messageKey);
            if (!enAudio.ok && hasSpeech && spokenTextEn) {
                await this.speakUtterance(spokenTextEn, {
                    lang: commonVoice?.lang || 'en-US',
                    voice: commonVoice,
                    pitch: 1,
                    rate: 1,
                });
            }
            await this.waitMs(350);

            // 3) Tamil message MP3
            const taAudio = await this.playAckTamilAudio(messageKey);
            if (!taAudio.ok) {
                const taRoman = String(spokenTextTaRoman || '')
                    .replace(/,/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();
                const taMsg = spokenTextTa || '';
                const taVoice = hasSpeech ? this.pickFemaleIndianVoice('ta') : null;
                if (taMsg && taVoice) {
                    await this.speakUtterance(taMsg, {
                        lang: taVoice.lang || 'ta-IN',
                        voice: taVoice,
                        pitch: 1,
                        rate: 0.95,
                    });
                } else if (taRoman && hasSpeech) {
                    await this.speakUtterance(taRoman, {
                        lang: commonVoice?.lang || 'en-US',
                        voice: commonVoice,
                        pitch: 1,
                        rate: 0.95,
                    });
                }
            }
        } catch (e) {
            /* TTS best-effort */
        }
        this._ackVoicePlaying = false;
        if (typeof onFinished === 'function') {
            onFinished();
        }
    };

    /** True while patient must stay for ack voice-over before ending. */
    shouldWaitForAckVoice = () => !!(
        this.props.isCustomer
        && (this._ackVoicePlaying || (this._patientAckReceived && this._pendingEndAfterAckVoice && !this._ackFeedbackStarted))
    );

    /** After bilingual ack voice-over: close session and open feedback. */
    finishPatientAckAndGoFeedback = () => {
        if (!this.props.isCustomer) {
            return;
        }
        if (this._ackFeedbackStarted) {
            return;
        }
        // Still speaking — never end early
        if (this._ackVoicePlaying) {
            this._pendingEndAfterAckVoice = true;
            return;
        }
        this._ackFeedbackStarted = true;
        this._pendingEndAfterAckVoice = false;
        this._isEndingCall = true;
        this.clearPatientHierarchyTimers();
        this._headRedirectStarted = false;
        this._wardRedirectStarted = false;
        this._headRedirectInProgress = false;
        this._wardRedirectInProgress = false;
        this.stopNurseAckSpeech(true);
        this.stopPatientRingTone();
        this.releaseCallSession();
        const roomId = this.props.match.params.roomId;
        const params = this.buildPatientEndCallParams();
        try {
            this.props.customerDeclineAction(params, () => {
                this.goToPatientFeedback();
            });
        } catch (e) {
            this.goToPatientFeedback();
        }
        setTimeout(() => {
            if (this.props.isCustomer) {
                try {
                    this.goToPatientFeedback();
                } catch (err) {
                    /* ignore */
                }
            }
        }, 2500);
    };

    handleNurseQuickAck = (response = {}) => {
        if (!this.props.isCustomer || this._ackFeedbackStarted || this._patientAckReceived) {
            return;
        }
        const agentName = response?.agentName || response?.spokenName || 'Nurse';
        const message = response?.message || response?.spokenTextEn || '';
        const messageTa = response?.messageTa || response?.spokenTextTa || '';
        const romanByKey = {
            on_the_way: 'Naan vanthukondirukiren',
            reach_30_sec: 'Naan mupathu nimidathil vanthuviduven',
            reach_1_min: 'Naan oru nimishathula vandhuduven',
        };
        const messageTaRoman = response?.messageTaRoman
            || response?.spokenTextTaRoman
            || romanByKey[response?.messageKey]
            || '';
        if (!message) {
            return;
        }
        const spokenName = response?.spokenName || agentName;
        // Prefer plain message parts (not "Name. message") for sequenced speech
        let spokenTextEn = response?.spokenTextEn || message;
        if (spokenTextEn.startsWith(`${agentName}.`)) {
            spokenTextEn = spokenTextEn.slice(agentName.length + 1).trim();
        }
        let spokenTextTa = response?.spokenTextTa || messageTa;
        if (spokenTextTa && spokenTextTa.startsWith(`${agentName}.`)) {
            spokenTextTa = spokenTextTa.slice(agentName.length + 1).trim();
        }
        const spokenTextTaRoman = response?.spokenTextTaRoman || messageTaRoman;

        this._patientAckReceived = true;
        this._pendingEndAfterAckVoice = true;
        // Stop hierarchy escalation — nurse ended via ack; patient waits for voice then feedback
        this.clearPatientHierarchyTimers();
        this._headRedirectStarted = false;
        this._wardRedirectStarted = false;
        this._headRedirectInProgress = false;
        this._wardRedirectInProgress = false;
        this.stopPatientRingTone();
        this.setState({
            nurseAckMessage: message,
            nurseAckAgentName: agentName,
            agentName: agentName || this.state.agentName,
            callPhase: 'ringing',
            ip_head_redirect_model: false,
        });
        this.updateCallStatusOverlay(
            'Nurse is coming',
            messageTa
                ? `${agentName}: ${message} / ${messageTa}`
                : `${agentName}: ${message}`,
            { showLoader: false }
        );
        try {
            if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
                navigator.vibrate([80, 40, 80]);
            }
        } catch (e) {
            /* ignore */
        }
        this.speakNurseAckBilingual({
            spokenName,
            spokenTextEn,
            spokenTextTa,
            spokenTextTaRoman,
            messageKey: response?.messageKey,
            onFinished: () => this.finishPatientAckAndGoFeedback(),
        });
    };

    /** Soft one-shot haptic when nurse answers (supported browsers / phones only). */
    vibratePatientAnswered = () => {
        if (!this.props.isCustomer) {
            return;
        }
        try {
            if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
                navigator.vibrate(200);
            }
        } catch (e) {
            /* ignore — vibration is optional */
        }
    };

    formatCallDuration = (totalSeconds) => {
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
    };

    startCallDurationTimer = () => {
        if (this._callDurationInterval) {
            return;
        }
        this._callDurationStart = Date.now();
        this.setState({ showCallDuration: true, callDurationDisplay: '00:00:00' });
        this._callDurationInterval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - this._callDurationStart) / 1000);
            this.setState({ callDurationDisplay: this.formatCallDuration(elapsed) });
        }, 1000);

        // Hard cap: auto-end after 1 hour so orphaned sessions cannot run forever.
        if (this._maxCallDurationTimer) {
            clearTimeout(this._maxCallDurationTimer);
        }
        this._maxCallDurationTimer = setTimeout(() => {
            if (this._isEndingCall) {
                return;
            }
            try {
                window.alert('Call ended automatically after 1 hour.');
            } catch (e) {
                // ignore
            }
            this.endCall();
        }, 60 * 60 * 1000);
    };

    stopCallDurationTimer = () => {
        if (this._callDurationInterval) {
            clearInterval(this._callDurationInterval);
            this._callDurationInterval = null;
        }
        if (this._maxCallDurationTimer) {
            clearTimeout(this._maxCallDurationTimer);
            this._maxCallDurationTimer = null;
        }
    };

    clearPatientHierarchyTimers = () => {
        if (timmerId) {
            clearTimeout(timmerId);
            timmerId = null;
        }
        if (this._wardEscalationTimer) {
            clearTimeout(this._wardEscalationTimer);
            this._wardEscalationTimer = null;
        }
        if (this._patientTotalTimer) {
            clearTimeout(this._patientTotalTimer);
            this._patientTotalTimer = null;
        }
    };

    getWardRedirectContext = () => {
        const base = this.getHeadRedirectContext();
        const wardUserId = localStorage.getItem('srm_ip_ward_user_id') || base.mapping?.SrmIpRoom?.SrmIpWard?.headUserId;
        return {
            ...base,
            wardUserId,
        };
    };

    /** Vendor-configured escalation seconds (defaults 15 / 25 / 20). */
    getEscalationSeconds = () => {
        const clamp = (raw, fallback) => {
            const n = parseInt(raw, 10);
            if (!Number.isFinite(n) || n < 5 || n > 180) {
                return fallback;
            }
            return n;
        };
        const floorToWardSec = clamp(localStorage.getItem('srm_ip_floor_to_ward_sec'), 15);
        const wardToHeadSec = clamp(localStorage.getItem('srm_ip_ward_to_head_sec'), 25);
        const headRingTimeoutSec = clamp(localStorage.getItem('srm_ip_head_ring_timeout_sec'), 20);
        return {
            floorToWardSec,
            wardToHeadSec,
            headRingTimeoutSec,
            totalWaitSec: floorToWardSec + wardToHeadSec + headRingTimeoutSec,
        };
    };

    scheduleWardToHeadRedirect = () => {
        if (!this.props.isCustomer) {
            return;
        }
        if (this._wardEscalationTimer) {
            clearTimeout(this._wardEscalationTimer);
        }
        const { wardToHeadSec } = this.getEscalationSeconds();
        this._wardEscalationTimer = setTimeout(() => {
            const onWardRoute = window.location.pathname.includes('/srm_ward/');
            const stillRinging = this.state.callPhase === 'ringing' && !this._headRedirectStarted;
            if (!onWardRoute || !stillRinging || this._isEndingCall || this._patientAckReceived || this.shouldWaitForAckVoice()) {
                return;
            }
            endCallListing = false;
            this._headRedirectStarted = true;
            this.setState({ ip_head_redirect_model: true }, () => {
                this.redirectToHead();
            });
        }, wardToHeadSec * 1000);
    };

    schedulePatientTotalWaitTimeout = () => {
        if (!this.props.isCustomer) {
            return;
        }
        if (this._patientTotalTimer) {
            clearTimeout(this._patientTotalTimer);
            this._patientTotalTimer = null;
        }
        const { totalWaitSec, headRingTimeoutSec } = this.getEscalationSeconds();
        const startedAt = parseInt(localStorage.getItem('srm_patient_call_started_at') || '0', 10)
            || this._callStartedAt
            || Date.now();
        let remainingMs = Math.max(0, (totalWaitSec * 1000) - (Date.now() - startedAt));
        // After floor→ward→head redirects, leftover total-wait is often ~0 on /srm_head remount.
        // Give a full Head ring window so we don't immediately decline while Head is answering.
        if (remainingMs < 1000 && window.location.pathname.includes('/srm_head/')) {
            remainingMs = headRingTimeoutSec * 1000;
        }
        this._patientTotalTimer = setTimeout(() => {
            // 'connecting' = nurse already attended; do not auto-decline mid-handshake.
            // Ack voice-over: wait for speech, then finishPatientAckAndGoFeedback ends the call.
            if (
                this._isEndingCall
                || this._patientAckReceived
                || this.shouldWaitForAckVoice()
                || this.state.callPhase === 'connected'
                || this.state.callPhase === 'connecting'
            ) {
                return;
            }
            this._isEndingCall = true;
            endCallListing = true;
            const params = this.buildPatientEndCallParams({ reason: 'not_answered' });
            this.props.customerDeclineAction(params, () => {
                localStorage.removeItem('srm_patient_call_started_at');
                this.goToPatientFeedback();
            });
        }, remainingMs);
    };

    getHeadRedirectContext = () => {
        const srmIpServiceId = localStorage.getItem('srmIpServiceId');
        const roomServiceData = this.props?.currentServices || {};
        const mappings = roomServiceData?.SrmIpRoomServiceMappings || [];
        let mapping = mappings.find((item) => String(item?.srmIpServiceId) === String(srmIpServiceId));
        if (!mapping && srmIpServiceId) {
            mapping = {
                srmIpServiceId: srmIpServiceId,
                srmIpRoomId: localStorage.getItem('srm_ip_mapping_room_id'),
                SrmIpServiceMaster: {
                    userId: localStorage.getItem('srm_ip_head_user_id'),
                },
            };
        }
        const encryptRoomId = roomServiceData?.encryptRoomId
            || localStorage.getItem('srm_ip_encrypt_room_id')
            || localStorage.getItem('srm_ip_room');
        const headUserId = mapping?.SrmIpServiceMaster?.userId
            || localStorage.getItem('srm_ip_head_user_id');
        return {
            mapping,
            encryptRoomId,
            headUserId,
        };
    };

    getCallStatusIconHtml = (showLoader = false) => {
        if (showLoader) {
            return '<div class="nurse-spinner" aria-hidden="true"><span></span><span></span><span></span></div>';
        }
        return '<div class="call-status-avatar" aria-hidden="true"><i class="fa-solid fa-user-nurse"></i></div>';
    };

    /** Show ringing/connecting UI immediately — do not wait for camera/WebRTC (avoids black screen). */
    ensureCallStatusOverlay = (phase = 'ringing', overrides = {}) => {
        const container = document.getElementById('videos-container');
        if (!container) {
            return;
        }
        const showConnecting = phase === 'connecting';
        if (this.props.isCustomer) {
            if (showConnecting) {
                this.stopPatientRingTone();
            } else if (this._patientAckReceived || overrides.showMediaRetry) {
                this.stopPatientRingTone();
            } else {
                this.startPatientRingTone();
            }
        }
        const statusTitle = overrides.title || (showConnecting
            ? 'Connecting...'
            : (this._patientAckReceived ? 'Nurse is coming' : 'Ringing...'));
        const statusSubtitle = overrides.subtitle || (showConnecting
            ? (this.state.agentName
                ? `Connecting with ${this.state.agentName}`
                : 'Establishing video connection')
            : (this._patientAckReceived && this.state.nurseAckMessage
                ? `${this.state.nurseAckAgentName || 'Nurse'}: ${this.state.nurseAckMessage}`
                : 'Waiting for Nurse to answer'));
        const showRetry = !!overrides.showMediaRetry;
        let overlay = container.querySelector('.initial-connect');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'initial-connect call-phase-' + (showConnecting ? 'connecting' : 'ringing');
            overlay.innerHTML = `
                <div class="call-status-box">
                    <div class="call-status-avatar" aria-hidden="true"${showConnecting ? ' style="display:none"' : ''}><i class="fa-solid fa-user-nurse"></i></div>
                    <h1 class="call-status-title">${statusTitle}</h1>
                    <p class="call-status-subtitle">${statusSubtitle}</p>
                    <div class="call-status-icon">${showConnecting ? this.getCallStatusIconHtml(true) : ''}</div>
                    ${showRetry ? '<button type="button" class="btn btn-primary mt-3 patient-media-retry-btn">Try again</button>' : ''}
                </div>
            `;
            container.appendChild(overlay);
            this.bindPatientMediaRetryButton(overlay);
            return;
        }
        this.updateCallStatusOverlay(statusTitle, statusSubtitle, { showLoader: showConnecting && !showRetry });
        if (showRetry) {
            let btn = overlay.querySelector('.patient-media-retry-btn');
            if (!btn) {
                btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'btn btn-primary mt-3 patient-media-retry-btn';
                btn.innerHTML = 'Try again';
                const box = overlay.querySelector('.call-status-box');
                if (box) {
                    box.appendChild(btn);
                }
            }
            this.bindPatientMediaRetryButton(overlay);
        }
    };

    bindPatientMediaRetryButton = (overlay) => {
        const btn = overlay && overlay.querySelector('.patient-media-retry-btn');
        if (!btn || btn.dataset.bound === '1') {
            return;
        }
        btn.dataset.bound = '1';
        btn.addEventListener('click', () => {
            this.retryPatientMediaAndJoin();
        });
    };

    retryPatientMediaAndJoin = async () => {
        const perm = await ensurePatientMediaPermission();
        if (!perm.ok) {
            toast.error(patientMediaPermissionMessage(perm.reason));
            this.ensureCallStatusOverlay('ringing', {
                title: 'Camera & Microphone needed',
                subtitle: patientMediaPermissionMessage(perm.reason),
                showLoader: false,
                showMediaRetry: true,
            });
            return;
        }
        this._mediaPermissionBlocked = false;
        this.setState({ mediaPermissionBlocked: false });
        this.ensureCallStatusOverlay('ringing', {
            title: 'Ringing...',
            subtitle: 'Waiting for Nurse to answer',
            showLoader: false,
        });
        try {
            this.joinVideConferencing();
        } catch (e) {
            console.warn('retryPatientMediaAndJoin', e);
        }
    };

    toggleVideoSwap = () => {
        this.setState(
            (prev) => ({ isVideoSwapped: !prev.isVideoSwapped }),
            () => this.refreshVideoSwapTargets()
        );
    };

    /** WhatsApp-style: tap the mini video to swap local/remote main vs PiP */
    refreshVideoSwapTargets = () => {
        const container = document.getElementById('videos-container');
        if (!container) {
            return;
        }
        const localEl = container.querySelector('.media-container.front-video');
        const remoteEl = container.querySelector('.media-container.background-video');
        if (!localEl && !remoteEl) {
            return;
        }
        const swapped = !!this.state.isVideoSwapped;
        if (localEl) {
            localEl.setAttribute('title', swapped ? '' : 'Tap to swap');
            localEl.setAttribute('aria-label', swapped ? 'Your video (main)' : 'Your video — tap to swap');
        }
        if (remoteEl) {
            remoteEl.setAttribute('title', swapped ? 'Tap to swap' : '');
            remoteEl.setAttribute('aria-label', swapped ? 'Remote video — tap to swap' : 'Remote video (main)');
        }
    };

    bindVideoSwapClick = () => {
        const container = document.getElementById('videos-container');
        if (!container || container.dataset.swapBound === '1') {
            return;
        }
        container.dataset.swapBound = '1';
        container.addEventListener('click', (e) => {
            // Only the current PiP is clickable for swap
            const pipSelector = this.state.isVideoSwapped
                ? '.media-container.background-video'
                : '.media-container.front-video';
            const pip = e.target.closest(pipSelector);
            if (!pip || !container.contains(pip)) {
                return;
            }
            // Ignore clicks on call controls overlay
            if (e.target.closest('.customer-end-call-content') || e.target.closest('.icons')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            this.toggleVideoSwap();
        });
        this.refreshVideoSwapTargets();
    };

    applyRemoteCameraOff = (isOff, { isVirtualBackground, isScreenView } = {}) => {
        const vb = typeof isVirtualBackground === 'boolean' ? isVirtualBackground : this.state.isVirtualBackground;
        const screenView = typeof isScreenView === 'boolean' ? isScreenView : this.state.isScreenView;
        const off = !!isOff;
        this._pendingRemoteCamOff = off;
        // Signaling is source of truth — track poll must not fight this
        this._remoteCamOffFromSignal = off;
        this.setState({ avatarmain: off });

        // Hide ALL remote video pixels — id can change after renegotiation
        const remoteVideos = document.querySelectorAll(
            '#videos-container .media-container.background-video video, #videos-container #video'
        );
        const bgCanvas = document.getElementById('bgCanvas');
        const container = document.getElementById('videos-container');

        if (off) {
            if (container) {
                container.classList.add('remote-cam-off');
            }
            remoteVideos.forEach((remoteVideo) => {
                remoteVideo.style.visibility = 'hidden';
                remoteVideo.style.opacity = '0';
            });
            if (bgCanvas) {
                bgCanvas.style.visibility = 'hidden';
                bgCanvas.style.opacity = '0';
            }
            return;
        }

        if (container) {
            container.classList.remove('remote-cam-off');
        }
        if (vb && bgCanvas) {
            bgCanvas.style.visibility = '';
            bgCanvas.style.opacity = '';
            if (screenView) {
                bgCanvas.setAttribute('style', 'display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;');
            } else {
                bgCanvas.style.display = 'block';
            }
            remoteVideos.forEach((remoteVideo) => {
                remoteVideo.style.display = 'none';
                remoteVideo.style.visibility = '';
                remoteVideo.style.opacity = '';
            });
        } else {
            if (bgCanvas) {
                bgCanvas.style.display = 'none';
                bgCanvas.style.visibility = '';
                bgCanvas.style.opacity = '';
            }
            remoteVideos.forEach((remoteVideo) => {
                remoteVideo.style.display = 'block';
                remoteVideo.style.visibility = '';
                remoteVideo.style.opacity = '';
            });
        }
    };

    getNameInitial = (name, fallback = 'U') => {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            return fallback;
        }
        return trimmed.charAt(0).toUpperCase();
    };

    /**
     * Track poll is only a helper for initial join.
     * Once nurse signals cam-off, never clear from track.muted — sender often leaves
     * last frame "live"/unmuted, which caused cam-off ↔ freeze flicker.
     */
    syncRemoteCameraOffFromTracks = (stream) => {
        if (this._remoteCamOffFromSignal) {
            return;
        }
        const target = stream || this._remoteMediaStream;
        if (!target || typeof target.getVideoTracks !== 'function') {
            return;
        }
        const tracks = target.getVideoTracks();
        if (!tracks.length) {
            return;
        }
        const allLiveUnmuted = tracks.every((t) => t && t.muted === false && t.readyState === 'live');
        if (allLiveUnmuted) {
            this._nurseCamConfirmedOn = true;
            this.applyRemoteCameraOff(false);
        }
    };

    startRemoteCameraOffMonitor = (stream) => {
        this._remoteMediaStream = stream || this._remoteMediaStream;
        if (this._remoteCamOffPoll) {
            clearInterval(this._remoteCamOffPoll);
        }
        this.syncRemoteCameraOffFromTracks(this._remoteMediaStream);
        this._remoteCamOffPoll = setInterval(() => {
            this.syncRemoteCameraOffFromTracks(this._remoteMediaStream);
        }, 900);
    };

    stopRemoteCameraOffMonitor = () => {
        if (this._remoteCamOffPoll) {
            clearInterval(this._remoteCamOffPoll);
            this._remoteCamOffPoll = null;
        }
    };

    attachRemoteVideoMuteListeners = (stream) => {
        if (!stream || typeof stream.getVideoTracks !== 'function') {
            return;
        }
        this._remoteMediaStream = stream;
        stream.getVideoTracks().forEach((track) => {
            if (track._remoteMuteBound) {
                return;
            }
            track._remoteMuteBound = true;
            // Do not clear cam-off on track unmute while nurse signaled camera off
            // (last painted frame often stays unmuted → freeze flicker).
            track.addEventListener('unmute', () => {
                if (this._remoteCamOffFromSignal) {
                    return;
                }
                this._nurseCamConfirmedOn = true;
                this.applyRemoteCameraOff(false);
            });
        });
        this.startRemoteCameraOffMonitor(stream);
    };

    updateCallStatusOverlay = (title, subtitle = '', { showLoader = false } = {}) => {
        const overlay = document.querySelector('#videos-container .initial-connect');
        if (!overlay) {
            return;
        }
        // Connecting / answered: always stop patient ring. Do not auto-start here
        // (media-permission retry uses showLoader=false and must stay silent).
        if (this.props.isCustomer && showLoader) {
            this.stopPatientRingTone();
        }
        overlay.classList.toggle('call-phase-connecting', !!showLoader);
        overlay.classList.toggle('call-phase-ringing', !showLoader);
        const titleEl = overlay.querySelector('.call-status-title');
        const subtitleEl = overlay.querySelector('.call-status-subtitle');
        const iconWrap = overlay.querySelector('.call-status-icon');
        const avatarEl = overlay.querySelector('.call-status-avatar');
        if (titleEl) {
            titleEl.textContent = title;
        }
        if (subtitleEl) {
            subtitleEl.textContent = subtitle || '';
            subtitleEl.style.display = subtitle ? 'block' : 'none';
        }
        if (showLoader) {
            if (avatarEl) {
                avatarEl.style.display = 'none';
            }
            if (iconWrap) {
                iconWrap.innerHTML = this.getCallStatusIconHtml(true);
            }
        } else {
            if (avatarEl) {
                avatarEl.style.display = '';
            }
            if (iconWrap) {
                iconWrap.innerHTML = '';
            }
        }
    };

    removeCallStatusOverlay = () => {
        this.stopPatientRingTone();
        const overlay = document.querySelector('#videos-container .initial-connect');
        if (overlay) {
            overlay.remove();
        }
        this.clearPatientHierarchyTimers();
        this.setState({ callPhase: 'connected', ip_head_redirect_model: false });
        this.startCallDurationTimer();
    };

    handleVideoDevicesChanged = () => {
        this.refreshVideoInputDeviceList();
    };

    refreshVideoInputDeviceList = async () => {
        try {
            const summary = await getVideoDevicesSummary();
            const canSwitchCamera = shouldOfferCameraSwitch({
                ids: summary.ids,
                videoInputCount: summary.videoInputCount,
            });
            const videoInputDeviceIds = summary.ids;
            let activeVideoDeviceIndex = this.state.activeVideoDeviceIndex;
            const currentTrack = this.mediaStream?.getVideoTracks?.()?.[0];
            const currentId = currentTrack?.getSettings?.()?.deviceId;
            if (currentId && videoInputDeviceIds.length) {
                const idx = videoInputDeviceIds.indexOf(currentId);
                if (idx >= 0) activeVideoDeviceIndex = idx;
            }
            this.setState({ videoInputDeviceIds, canSwitchCamera, activeVideoDeviceIndex });
            return { ...summary, canSwitchCamera };
        } catch {
            this.setState({ videoInputDeviceIds: [], canSwitchCamera: false });
            return { ids: [], videoInputCount: 0, canSwitchCamera: false };
        }
    };

    switchCamera = async () => {
        const { isSwitchingCamera, isVideoMute } = this.state;
        if (!this.mediaStream || !this.connection || isSwitchingCamera) {
            return;
        }
        const snap = await this.refreshVideoInputDeviceList();
        if (!snap.canSwitchCamera) {
            return;
        }
        const { ids } = snap;
        const useDeviceIdCycle = ids.filter(Boolean).length >= 2;
        let targetDeviceId = null;
        let nextIdx = 0;

        if (useDeviceIdCycle) {
            const currentTrackProbe = this.mediaStream.getVideoTracks()[0];
            const currentId = currentTrackProbe?.getSettings?.()?.deviceId;
            if (currentId && ids.includes(currentId)) {
                nextIdx = (ids.indexOf(currentId) + 1) % ids.length;
            } else {
                nextIdx = (this.state.activeVideoDeviceIndex + 1) % ids.length;
            }
            targetDeviceId = ids[nextIdx];
            let guard = 0;
            while (currentId && targetDeviceId === currentId && guard < ids.length) {
                nextIdx = (nextIdx + 1) % ids.length;
                targetDeviceId = ids[nextIdx];
                guard += 1;
            }
        }

        const currentTrack = this.mediaStream.getVideoTracks()[0];
        const pip = document.querySelector('#videos-container .media-container.front-video');
        pip?.classList?.add('camera-switch-lock');
        this.setState({ isSwitchingCamera: true });
        try {
            const newStream = await getUserMediaForCameraSwitch({
                targetDeviceId: useDeviceIdCycle ? targetDeviceId : null,
                currentVideoTrack: currentTrack,
                priorFacingMode: currentTrack?.getSettings?.()?.facingMode,
                mediaStream: this.mediaStream,
            });
            const newVideoTrack = newStream.getVideoTracks()[0];
            if (!newVideoTrack || newVideoTrack.readyState === 'ended') {
                try {
                    newVideoTrack?.stop();
                } catch {
                    /* ignore */
                }
                throw new Error('SWITCH_CAMERA_NO_TRACK');
            }

            const oldVideoTracks = [...this.mediaStream.getVideoTracks()];
            const participants =
                typeof this.connection.getAllParticipants === 'function'
                    ? this.connection.getAllParticipants()
                    : [];

            if (participants.length > 0) {
                if (typeof this.connection.replaceTrack !== 'function') {
                    try {
                        newVideoTrack.stop();
                    } catch {
                        /* ignore */
                    }
                    throw new Error('SWITCH_CAMERA_NO_REPLACE');
                }
                try {
                    this.connection.replaceTrack(newVideoTrack, null, true);
                } catch (replaceErr) {
                    try {
                        newVideoTrack.stop();
                    } catch {
                        /* ignore */
                    }
                    throw replaceErr;
                }
            }

            oldVideoTracks.forEach((t) => {
                try {
                    this.mediaStream.removeTrack(t);
                } catch {
                    /* ignore */
                }
                if (t.id !== newVideoTrack.id) {
                    try {
                        t.stop();
                    } catch {
                        /* ignore */
                    }
                }
            });
            const alreadyAttached = this.mediaStream
                .getVideoTracks()
                .some((t) => t === newVideoTrack);
            if (!alreadyAttached) {
                this.mediaStream.addTrack(newVideoTrack);
            }
            if (isVideoMute) {
                newVideoTrack.enabled = false;
            }
            const canvasVideo = document.getElementById('canvasVideo');
            if (canvasVideo) {
                this.playStreamSafely(canvasVideo);
            }
            this.setState({ activeVideoDeviceIndex: nextIdx });
            await this.refreshVideoInputDeviceList();
        } catch (err) {
            console.warn('switchCamera', err);
            if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
                toast.error('Camera permission is required to switch.');
            } else {
                if (this.mediaStream && this.mediaStream.getVideoTracks().length === 0) {
                    try {
                        const rescue = await navigator.mediaDevices.getUserMedia({
                            video: { facingMode: { ideal: 'user' } },
                            audio: false,
                        });
                        const rt = rescue.getVideoTracks()[0];
                        if (rt) {
                            this.mediaStream.addTrack(rt);
                            if (typeof this.connection.replaceTrack === 'function') {
                                try {
                                    this.connection.replaceTrack(rt, null, true);
                                } catch {
                                    /* ignore */
                                }
                            }
                            if (isVideoMute) {
                                rt.enabled = false;
                            }
                            const canvasVideo = document.getElementById('canvasVideo');
                            if (canvasVideo) {
                                this.playStreamSafely(canvasVideo);
                            }
                        }
                    } catch {
                        /* ignore */
                    }
                }
                toast.error(SWITCH_CAMERA_NOT_SUPPORTED_MSG);
            }
        } finally {
            pip?.classList?.remove('camera-switch-lock');
            this.setState({ isSwitchingCamera: false });
        }
    };

    playStreamSafely = (media) => {
        if (!media || typeof media.play !== 'function') {
            return;
        }
        // Cancel prior play race on the same element (srcObject reload / double-call).
        const token = (media._playToken || 0) + 1;
        media._playToken = token;
        try {
            if (typeof media.pause === 'function' && !media.paused) {
                // Don't pause if already playing the same stream — only gate new play()
            }
        } catch (_e) {
            /* ignore */
        }
        let playPromise;
        try {
            playPromise = media.play();
        } catch (_syncErr) {
            return;
        }
        if (!playPromise || typeof playPromise.then !== 'function') {
            return;
        }
        playPromise.then(() => {
            /* playing */
        }).catch((err) => {
            if (media._playToken !== token) {
                return;
            }
            const name = err && (err.name || err.message) || '';
            // AbortError is expected when play() is interrupted by a new load/play — ignore it.
            if (/AbortError|interrupted/i.test(String(name))) {
                return;
            }
            // Autoplay policy: retry muted once (keep local preview visible).
            if (/NotAllowed|NotSupported/i.test(String(name))) {
                try {
                    media.muted = true;
                } catch (_m) {
                    /* ignore */
                }
                const retry = media.play();
                if (retry && typeof retry.catch === 'function') {
                    retry.catch(() => { /* ignore */ });
                }
            }
        });
    }

    appHeight = () => {
        if (this._appHeightTimer) clearTimeout(this._appHeightTimer);
        if (this._appHeightRaf) cancelAnimationFrame(this._appHeightRaf);
        this._appHeightTimer = setTimeout(() => {
            this._appHeightTimer = null;
            this._appHeightRaf = requestAnimationFrame(() => {
                this._appHeightRaf = null;
                const doc = document.documentElement;
                const h = window.innerHeight;
                doc.style.setProperty('--app-height', `${h}px`);
                doc.style.setProperty('--video-height', `${h * 0.3}px`);
                doc.style.setProperty('--chat-height', `${h * 0.7}px`);
                doc.style.setProperty('--screen-share-height', `${h * 0.85}px`);
            });
        }, 200);
    }

    componentWillUnmount() {
        // Browser Back / route change does NOT fire beforeunload — end nurse call here
        this.stopPatientRingTone();
        this.stopRemoteCameraOffMonitor();
        this.clearPatientCamAnnounceTimers();
        // Do not cancel ack voice mid-play unless feedback nav already started
        if (!this.shouldWaitForAckVoice()) {
            this.stopNurseAckSpeech(true);
            this.endPatientCallOnUnexpectedLeave();
        }
        this.stopCallDurationTimer();
        this.clearPatientHierarchyTimers();
        this.hideReconnectOverlay();
        window.removeEventListener('online', this._onNetworkOnline);
        if (this._appHeightTimer) {
            clearTimeout(this._appHeightTimer);
            this._appHeightTimer = null;
        }
        if (this._appHeightRaf) {
            cancelAnimationFrame(this._appHeightRaf);
            this._appHeightRaf = null;
        }
        window.removeEventListener('resize', this.appHeight)
        try {
            window.removeEventListener('beforeunload', this.handleTabClose);
            window.removeEventListener('pagehide', this.handlePageHide);
        } catch {
            /* ignore */
        }
        if (navigator.mediaDevices && navigator.mediaDevices.removeEventListener) {
            navigator.mediaDevices.removeEventListener('devicechange', this.handleVideoDevicesChanged);
        }
        this.setState({ localStreamStarted: false });
    }

    /**
     * Patient pressed Back / left call page without End Call.
     * Still ends appointment so the nurse stops ringing / disconnects.
     */
    endPatientCallOnUnexpectedLeave = () => {
        if (!this.props.isCustomer) {
            return;
        }
        // Ack voice-over still playing — keep speech, but detach live A/V
        if (this.shouldWaitForAckVoice()) {
            this._pendingEndAfterAckVoice = true;
            try {
                this.releaseCallSession({ keepAckSpeech: true });
            } catch (e) {
                /* ignore */
            }
            return;
        }
        if (this._isEndingCall || this._blockedSessionStart || this._headRedirectStarted || this._wardRedirectStarted) {
            return;
        }
        const roomId = this.props.match?.params?.roomId;
        if (!roomId) {
            return;
        }
        this._isEndingCall = true;
        PatientCallSession.markClosed(roomId);
        const payload = this.buildPatientEndCallParams();
        PatientCallSession.beaconEndCall(payload);
        try {
            this.props.customerDeclineAction(payload, () => { /* idempotent */ });
        } catch (e) {
            /* ignore */
        }
        try {
            this.releaseCallSession();
        } catch (e) {
            /* ignore */
        }
    };

    getConnectedDevices = async (type) => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.filter(device => device.kind === type)
    }

    getVideoElement = async () => {
        const video = await this.getConnectedDevices('videoinput');
        const audio = await this.getConnectedDevices('audioinput');
        const speaker = await this.getConnectedDevices('audiooutput');
        this.setState({ video, audio, speaker });
    }

    /** SRM end-call must send a truthy srm_ip_room or API looks up the wrong table. */
    resolveSrmIpRoomFlag = () => {
        const fromState = this.state.srm_ip_room;
        if (fromState) {
            return fromState;
        }
        const fromStorage =
            localStorage.getItem('srm_ip_room')
            || localStorage.getItem('srm_ip_encrypt_room_id');
        if (fromStorage) {
            return fromStorage;
        }
        const path = (typeof window !== 'undefined' && window.location && window.location.pathname) || '';
        if (/\/SRM_IP\//i.test(path) || /\/srm_head\//i.test(path) || /\/srm_ward\//i.test(path)) {
            return this.props.match?.params?.roomId || '1';
        }
        return null;
    }

    /** End/decline payload — if nurse never attended, mark patient_declined (missed history). */
    buildPatientEndCallParams = (extra = {}) => {
        const roomId = this.props.match?.params?.roomId;
        const phase = this.state.callPhase;
        const nurseNeverJoined = phase !== 'connected';
        return {
            roomId,
            callEndTime: new Date().getTime(),
            srm_ip_room: this.resolveSrmIpRoomFlag(),
            ...(nurseNeverJoined ? { reason: 'patient_declined' } : {}),
            ...extra,
        };
    }

    componentDidMount() {
        const isMobile = /Mobile/.test(window.navigator.userAgent) || window.matchMedia("(max-width: 767px)").matches;
        // Clear any leftover privacy overlays from older builds / cached tabs
        try {
            ['srm-ip-call-privacy-banner', 'srm-ip-call-privacy-watermark', 'srm-ip-call-privacy-toast']
                .forEach((id) => document.getElementById(id)?.remove());
            document.querySelectorAll('[data-srm-privacy],[id^="srm-ip-call-privacy"]').forEach((n) => n.remove());
        } catch (_e) {
            /* ignore */
        }
        this.setState({
            isMobileDevice: isMobile,
            // Patient: self full-page, nurse small (force even if props were late)
            ...(this.props.isCustomer ? { isVideoSwapped: true } : {}),
        })
        let srm_ip_room = localStorage.getItem("srm_ip_room") || null;
        const { attenedName = {} } = this.props
        const { tokenDetails = {} } = attenedName
        const isSrmIpAgent = tokenDetails?.userDetails?.VendorAgent?.isSrmIpAgent
        const roomId = this.props.match.params.roomId;
        const { isCustomer } = this.props;

        // Patient refreshed / re-entered a finished call → session ended → feedback (no call UI)
        if (isCustomer && PatientCallSession.shouldTreatAsSessionEnded(roomId)) {
            this.handlePatientSessionEndedOnLoad(roomId, srm_ip_room);
            return;
        }

        window.addEventListener('beforeunload', this.handleTabClose);
        window.addEventListener('pagehide', this.handlePageHide);
        if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
            navigator.mediaDevices.addEventListener('devicechange', this.handleVideoDevicesChanged);
        }
        this.setState({ roomId, srm_ip_room: srm_ip_room, isSrmIpAgent: isSrmIpAgent })

        if (isCustomer) {
            try {
                const vendorId = localStorage.getItem('srm_ip_vendor_id');
                const bedRoom = localStorage.getItem('srm_ip_room');
                if (vendorId && bedRoom) {
                    savePatientRoomEntry(`/SRM_IP/patient/${vendorId}/${bedRoom}`);
                } else if (bedRoom) {
                    savePatientRoomEntry(`/SRM_IP/custom/${bedRoom}`);
                } else {
                    const saved = getPatientRoomEntry();
                    if (!saved) {
                        savePatientRoomEntry(window.location.pathname, window.location.search || '');
                    }
                }
            } catch (_e) {
                /* ignore */
            }
            // Page lock is handled globally by PatientPageLock
        }

        if (isCustomer) {
            PatientCallSession.markActive(roomId);
            if (!localStorage.getItem('srm_patient_call_started_at')) {
                localStorage.setItem('srm_patient_call_started_at', String(Date.now()));
            }
            this._callStartedAt = parseInt(localStorage.getItem('srm_patient_call_started_at'), 10) || Date.now();
            const isHeadCallRoute = window.location.pathname.includes('/srm_head/');
            const isWardCallRoute = window.location.pathname.includes('/srm_ward/');
            setTimeout(() => this.ensureCallStatusOverlay('ringing', isHeadCallRoute ? {
                subtitle: 'Waiting for Head Nurse to answer',
            } : isWardCallRoute ? {
                subtitle: 'Waiting for Ward Nurse to answer',
            } : {}), 0);
            this.schedulePatientTotalWaitTimeout();
            if (isWardCallRoute) {
                this.scheduleWardToHeadRedirect();
            }
        }

        // Hospital emergency: start WebRTC immediately — do not wait for chatList API
        this.getVideoElement();
        window.addEventListener('resize', this.appHeight)
        this.appHeight()
        window.addEventListener('online', this._onNetworkOnline);
        this.loadVideoConferencing();
        this.setupAppCallSocket();

        const callBack = (response) => {
            if (response?.response_code === 0) {
                this.setState({ chatList: response?.response?.ChatMessages.sort((f, s) => f?.id - s?.id), customerName: response?.response?.customerName, agentName: response?.response?.agentName })
                // Agent VB list requires oauth — patients must not call it (401 + redirect).
                if (!this.props.isCustomer) {
                    this.getVirtualBackgroundList()
                }
            }
            else {
                if (!this.props.isCustomer) {
                    this.props.history.push('/store')
                } else if (
                    this.state.localStreamStarted
                    || this.connection
                    || (this._callStartedAt && (Date.now() - this._callStartedAt) < (this.getEscalationSeconds().floorToWardSec * 1000))
                ) {
                    // Keep emergency call alive — chat metadata is optional; REST can fail on flaky WiFi
                    console.warn('chatList failed; continuing live call');
                } else {
                    this.goToPatientFeedback();
                }
            }
        }
        const params = {
            roomId,
            srm_ip_room: srm_ip_room ? srm_ip_room : roomId
        }
        this.props.chatListAction(params, callBack)

    }

    handlePatientSessionEndedOnLoad = (roomId, srm_ip_room) => {
        this._isEndingCall = true;
        this._blockedSessionStart = true;
        PatientCallSession.clearLeftMidCall(roomId);
        PatientCallSession.clearActive(roomId);
        PatientCallSession.markClosed(roomId);
        PatientCallSession.flagSessionEndedMessage();
        const params = this.buildPatientEndCallParams({
            roomId,
            srm_ip_room: srm_ip_room || this.resolveSrmIpRoomFlag(),
            reason: 'patient_declined',
        });
        try {
            this.props.customerDeclineAction(params, () => { /* idempotent */ });
        } catch (e) {
            /* ignore */
        }
        // Toast shown once on feedback page via consumeSessionEndedMessage
        this.goToPatientFeedback({ showSessionEndedMsg: false });
    };

    goToPatientFeedback = ({ showSessionEndedMsg = false } = {}) => {
        // Ack voice still playing — wait until bilingual speech finishes,
        // but detach live A/V so Android clears Phone speaker notification.
        if (this.shouldWaitForAckVoice() && !this._ackFeedbackStarted) {
            this._pendingEndAfterAckVoice = true;
            try {
                this.releaseCallSession({ keepAckSpeech: true });
            } catch (e) {
                /* ignore */
            }
            return;
        }
        if (this._feedbackNavDone) {
            return;
        }
        this._feedbackNavDone = true;
        // Mark intentional leave so unmount does not fire a second decline
        this._isEndingCall = true;
        try {
            this.releaseCallSession();
        } catch (e) {
            /* ignore */
        }
        const roomId = this.props.match.params.roomId;
        if (roomId) {
            PatientCallSession.markClosed(roomId);
            PatientCallSession.clearActive(roomId);
            PatientCallSession.clearLeftMidCall(roomId);
            PatientCallSession.saveFeedbackRoomId(roomId);
        }
        localStorage.removeItem('srm_patient_call_started_at');
        if (showSessionEndedMsg) {
            PatientCallSession.flagSessionEndedMessage();
        } else {
            // Normal end call / nurse hangup — no toast on feedback
            PatientCallSession.clearSessionEndedMessage();
        }
        // replace — prevents browser Back returning to the live call page
        this.props.history.replace('/customer/feedback');
        try {
            this.mediaStream?.stop?.();
        } catch (e) {
            /* ignore */
        }
    };

    setupAppCallSocket = () => {
        if (window.location.hostname === 'localhost') {
            this.socketURL = SOCKET_URL;
        } else {
            this.socketURL = SOCKET_URL;
        }
        const socket = io(this.socketURL, { path: SOCKET_IO_PATH, transports: ['websocket'] });
        this.socket = socket;
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        socket.on(`chat/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            let arrayList = []
            arrayList = this.props.getChatListAction
            arrayList.push(response?.message.ChatMessages)
            this.props.appendChat(arrayList)
            let { unreadMessageCount = 0, isChatOpened } = this.state
            if (!isChatOpened) {
                unreadMessageCount = unreadMessageCount + 1
            }
            this.setState({ unreadMessageCount })
        })

        socket.on(`endcall/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            console.log("response", response);
            if (!isCustomer) {
                this.endCall(true);
                window.close()
                return;
            }
            // Ack voice-over in progress — nurse already closed; wait until speech finishes,
            // but detach live A/V so Android clears Phone speaker notification.
            if (this.shouldWaitForAckVoice()) {
                this._pendingEndAfterAckVoice = true;
                this.releaseCallSession({ keepAckSpeech: true });
                return;
            }
            // Nurse leg ended on purpose for head redirect — keep patient call alive
            if (!endCallListing || this._headRedirectInProgress || this._headRedirectStarted || this._wardRedirectInProgress || this._wardRedirectStarted) {
                return;
            }
            this.endCall(true);
            this.goToPatientFeedback();
        })
        socket.on(`call_connect/${roomId}`, (response) => {
            // Ignore name-only payloads (legacy chat list misuse). Real attend includes callPhase/status.
            const isRealAttend = response?.callPhase === 'connecting'
                || response?.status === 'connecting'
                || response?.callPhase === 'connected'
                || response?.status === 'connected';
            if (!isRealAttend) {
                if (response?.agentName || response?.customerName) {
                    this.setState({
                        customerName: response?.customerName || this.state.customerName,
                        agentName: response?.agentName || this.state.agentName,
                    });
                }
                return;
            }
            // Do not interrupt ack voice-over / feedback path
            if (this.shouldWaitForAckVoice() || this._patientAckReceived) {
                return;
            }
            const agentName = response?.agentName || '';
            // Nurse attended — cancel auto redirect to service head
            this.clearPatientHierarchyTimers();
            this._headRedirectStarted = false;
            this._wardRedirectStarted = false;
            this.stopNurseAckSpeech();
            this.setState({
                customerName: response?.customerName,
                agentName,
                callPhase: 'connecting',
                ip_head_redirect_model: false,
                nurseAckMessage: '',
                nurseAckAgentName: '',
            });
            // Duration starts only when remote media connects (removeCallStatusOverlay)
            if (this.props.isCustomer) {
                this.stopPatientRingTone();
                this.vibratePatientAnswered();
                this.updateCallStatusOverlay(
                    'Connecting...',
                    agentName ? `Connecting with ${agentName}` : 'Nurse answered. Establishing video...',
                    { showLoader: true }
                );
                const overlay = document.querySelector('#videos-container .initial-connect');
                if (overlay) {
                    overlay.classList.remove('call-phase-ringing');
                    overlay.classList.add('call-phase-connecting');
                }
            }
        })

        socket.on(`call_ack/${roomId}`, (response) => {
            this.handleNurseQuickAck(response);
        })

        socket.on(`screen/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            const { roomData } = response;
            const { isVirtualBackground } = this.state
            const { isCustomer } = this.props
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (roomData.stop) {
                this.setState({
                    isScreenView: false,
                    screenRoomId: ''
                })
                if (isCustomer && isVirtualBackground) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto")
                    this.canvasRef.current = backgroundCanvas
                }
            } else {
                this.setState({
                    isScreenView: true,
                    screenRoomId: roomData.screenRoomId
                })
                if (isCustomer && isVirtualBackground) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;")
                    this.canvasRef.current = backgroundCanvas
                }
            }
        })
        socket.on(`end_streaming/${roomId}`, (response) => {
            console.log("end Stream Socket------>", response)
        })
        socket.on(`age_verification/${roomId}`, (response) => {
            if (response?.message?.isAbove18) {
                toast.success(`Profile verified age is ${response?.message?.age}`)
                if (!isCustomer) {
                    this.onCaptureButtonClose()
                }
            } else {
                if (response?.message?.age === null) {
                    if (isCustomer) {
                        toast.error(`Could not able to recognized the image.`)
                    } else {
                        toast.error(`Could not able to recognized the image please retake.`)
                    }
                } else {
                    toast.error("Profile not verified.")
                }
            }

        })
        socket.on(`virtual_back_ground/${roomId}/${isCustomer ? 'customer' : 'store'}`, (response) => {
            if (response) {
                let findDinamicImgDiv = document.getElementsByClassName("dinamicImgDiv")
                if (findDinamicImgDiv.length > 0) {
                    document.querySelector('#videos-container').removeChild(findDinamicImgDiv[0])
                }
                let createDinamicImg = document.createElement('div');
                createDinamicImg.className = "dinamicImgDiv"
                createDinamicImg.innerHTML = `<img id='vbackground_${response?.id}' src=${this.setImg(response?.id, response?.imageURL)} alt="dinamic" />`
                document.querySelector('#videos-container').appendChild(createDinamicImg)
                let img = document.getElementById(`vbackground_${response?.id}`)
                img.setAttribute("style", 'display: none')
                this.setVideo(img, response?.id);
            }
        })
    }
    setImg = (key, imageURL) => {
        switch (key) {
            case 0:
                return NoEffect
            default:
                return imageURL
        }
    }
    onResults = async (results) => {
        const { isVirtualBackgroundIMG } = this.state
        // const img = document.getElementById(`vbackground_${isVirtualBackgroundIMG}`)
        const img = isVirtualBackgroundIMG
        const videoWidth = results?.image?.width;
        const videoHeight = results?.image?.height;
        this.canvasRef.current.width = videoWidth;
        this.canvasRef.current.height = videoHeight;

        const canvasElement = this.canvasRef.current;
        const canvasCtx = canvasElement.getContext("2d");

        canvasCtx.save();
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

        // Only overwrite existing pixels.
        canvasCtx.globalCompositeOperation = 'destination-atop';
        canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height);

        // Only overwrite missing pixels.

        canvasCtx.globalCompositeOperation = 'destination-over';
        canvasCtx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.restore();

    }
    virtualBackgroundSet = (stream, useSegment) => {
        const selfieSegmentation = new SelfieSegmentation({
            locateFile: (file) => {
                return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
            },
        });
        selfieSegmentation.setOptions({
            modelSelection: 1,
        });
        selfieSegmentation.onResults(this.onResults);
        if (segmentationStream) {
            const processFrame = async () => {
                await selfieSegmentation.send({ image: stream });
                requestAnimationFrame(processFrame);
            };
            requestAnimationFrame(processFrame);
            segmentationStream = false;
        }
        // if (useSegment) {
        //     myRef = requestAnimationFrame(processFrame);
        // } else {
        //     cancelAnimationFrame(myRef);
        // }
        //     const camera = new cam.Camera(stream, {
        //         onFrame: async () => {
        //             await selfieSegmentation.send({ image: stream });
        //         },
        //         width: 1280,
        //         height: 720
        //     });
        //     selfieSegmentation.send({ image: stream });
        //     if (useSegment) {
        //         camera.start();
        //     } else {
        //         camera.stop();
        //     }
    }
    handleTabClose = (event) => {
        if (this._isEndingCall || this._blockedSessionStart) {
            return;
        }
        const { isCustomer } = this.props;
        if (isCustomer) {
            // Ask patient to stay — do NOT end the call here (cancel would wrongly kill the session).
            // Actual leave is handled in pagehide when the document really unloads.
            if (!isPatientLeaveAllowed()) {
                event.preventDefault();
                event.returnValue = '';
            }
            return;
        }
        event.preventDefault();
        event.returnValue = '';
        this.endCall();
    }

    handlePageHide = (event) => {
        // BFCache park — page still exists; do not end the nurse call
        if (event && event.persisted) {
            return;
        }
        if (this._isEndingCall || this._blockedSessionStart) {
            return;
        }
        if (!this.props.isCustomer) {
            return;
        }
        const roomId = this.props.match.params.roomId;
        PatientCallSession.markLeftMidCall(roomId);
        PatientCallSession.beaconEndCall({
            roomId,
            srm_ip_room: this.resolveSrmIpRoomFlag(),
        });
    }

    /** Socket dropped while in call — soft reconnect same room (hospital: do not hard-reload). */
    _onCallSocketDisconnect = () => {
        if (this._isEndingCall) {
            return;
        }
        this.beginStreamReconnect('Network interrupted. Reconnecting…');
    }

    _onNetworkOnline = () => {
        if (this._isEndingCall) {
            return;
        }
        this.beginStreamReconnect('Network back. Restoring video…');
        this.attemptStreamReconnect();
    }

    _onRtcSocketReconnect = () => {
        if (this._isEndingCall || !this._isReconnectingStream) {
            return;
        }
        this.attemptStreamReconnect();
    }

    clearReconnectTimers = () => {
        if (this._reconnectRetryTimer) {
            clearTimeout(this._reconnectRetryTimer);
            this._reconnectRetryTimer = null;
        }
        if (this._reconnectInterval) {
            clearInterval(this._reconnectInterval);
            this._reconnectInterval = null;
        }
        if (this._reconnectDeadlineTimer) {
            clearTimeout(this._reconnectDeadlineTimer);
            this._reconnectDeadlineTimer = null;
        }
    }

    updateReconnectOverlayCountdown = () => {
        if (!this._reconnectStartedAt) {
            return;
        }
        const remainingMs = Math.max(0, (2 * 60 * 1000) - (Date.now() - this._reconnectStartedAt));
        const remainingSec = Math.ceil(remainingMs / 1000);
        const overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        const sub = overlay && overlay.querySelector('.stream-reconnect-sub');
        if (sub) {
            sub.textContent = remainingSec > 0
                ? `Retrying every 8s. Call ends in ${remainingSec}s if not restored`
                : 'Unable to reconnect. Ending call…';
        }
    }

    beginStreamReconnect = (message = 'Network interrupted. Reconnecting…') => {
        if (this._isEndingCall) {
            return;
        }
        this._isReconnectingStream = true;
        this.setState({ isReconnectingStream: true });
        this.showReconnectOverlay(message);

        if (!this._reconnectStartedAt) {
            this._reconnectStartedAt = Date.now();
        }

        this.clearReconnectTimers();
        this.updateReconnectOverlayCountdown();

        const remainingMs = Math.max(0, (2 * 60 * 1000) - (Date.now() - this._reconnectStartedAt));
        this._reconnectDeadlineTimer = setTimeout(() => {
            this.forceEndCallAfterReconnectTimeout();
        }, remainingMs || 1);

        // Try immediately, then every 8s (gentler on hospital 5–10 Mbps WiFi)
        this.attemptStreamReconnect();
        this._reconnectInterval = setInterval(() => {
            if (this._isEndingCall || !this._isReconnectingStream) {
                this.clearReconnectTimers();
                return;
            }
            this.updateReconnectOverlayCountdown();
            this.attemptStreamReconnect();
        }, 8000);
    }

    forceEndCallAfterReconnectTimeout = () => {
        if (this._isEndingCall) {
            return;
        }
        this.showReconnectOverlay('Unable to reconnect. Ending call…');
        const sub = document.querySelector('#videos-container .stream-reconnect-overlay .stream-reconnect-sub');
        if (sub) {
            sub.textContent = 'Connection could not be restored within 2 minutes';
        }
        this.clearReconnectTimers();
        this._reconnectRetryTimer = setTimeout(() => {
            this.hideReconnectOverlay();
            this.endCall();
        }, 900);
    }

    showReconnectOverlay = (message) => {
        let overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'stream-reconnect-overlay';
            overlay.innerHTML = `
                <div class="stream-reconnect-box">
                    <p class="stream-reconnect-title">${message}</p>
                    <p class="stream-reconnect-sub">Retrying every 8s. Call ends in 2 minutes if not restored</p>
                </div>
            `;
            const container = document.querySelector('#videos-container');
            if (container) {
                container.appendChild(overlay);
            }
        } else {
            const title = overlay.querySelector('.stream-reconnect-title');
            if (title) {
                title.textContent = message;
            }
        }
        this.updateReconnectOverlayCountdown();
    }

    hideReconnectOverlay = () => {
        const overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        if (overlay) {
            overlay.remove();
        }
        this.clearReconnectTimers();
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        this.setState({ isReconnectingStream: false });
    }

    ensureLocalMediaAlive = async () => {
        try {
            const tracks = this.mediaStream && this.mediaStream.getTracks ? this.mediaStream.getTracks() : [];
            const hasLiveAudio = tracks.some((t) => t.kind === 'audio' && t.readyState === 'live');
            const hasLiveVideo = tracks.some((t) => t.kind === 'video' && t.readyState === 'live');
            if (hasLiveAudio && hasLiveVideo) {
                return;
            }
            ensureMediaDevicesApi();
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true,
            });
            this.mediaStream = stream;
            if (this.connection) {
                this.connection.attachStreams = [stream];
                try {
                    if (typeof this.connection.replaceTrack === 'function' && stream.getVideoTracks()[0]) {
                        this.connection.replaceTrack(stream.getVideoTracks()[0]);
                    }
                } catch (e) {
                    /* ignore */
                }
            }
            this.applyHospitalSenderBitrate(400000);
            const localVideo = document.getElementById('canvasVideo');
            if (localVideo) {
                localVideo.srcObject = stream;
            }
        } catch (e) {
            /* camera may be unavailable while offline */
        }
    }

    attemptStreamReconnect = async () => {
        if (this._isEndingCall || !this._isReconnectingStream) {
            return;
        }
        await this.ensureLocalMediaAlive();
        this.rejoinCallRoom();
    }

    rejoinCallRoom = () => {
        const { roomId } = this.props.match.params;
        if (!this.connection || this._isEndingCall || !roomId) {
            return;
        }
        try {
            if (this.connection.socket && !this.connection.socket.connected) {
                try {
                    this.connection.socket.connect();
                } catch (e) {
                    /* ignore */
                }
            }
            this.connection.sdpConstraints.mandatory = {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: true
            };
            if (this.mediaStream) {
                this.connection.attachStreams = [this.mediaStream];
            }
            this.connection.openOrJoin(roomId, () => {
                this.attachRtcReconnectHandlers();
                try {
                    if (typeof this.connection.renegotiate === 'function') {
                        const peers = this.connection.getAllParticipants
                            ? this.connection.getAllParticipants()
                            : [];
                        if (peers && peers.length) {
                            peers.forEach((pid) => {
                                try {
                                    this.connection.renegotiate(pid);
                                } catch (e) {
                                    /* ignore */
                                }
                            });
                        } else {
                            this.connection.renegotiate();
                        }
                    }
                } catch (e) {
                    /* ignore */
                }
            });
        } catch (err) {
            /* next 5s interval will retry */
        }
    }

    attachRtcReconnectHandlers = () => {
        if (!this.connection || !this.connection.socket) {
            return;
        }
        try {
            this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.off('connect', this._onRtcSocketReconnect);
            this.connection.socket.on('connect', this._onRtcSocketReconnect);
        } catch (e) {
            /* ignore */
        }
        // Frozen video with socket still "up" — hospital WiFi common failure mode
        this.attachIceReconnectHandler();
    }

    attachIceReconnectHandler = () => {
        if (!this.connection || !this.props.isCustomer) {
            return;
        }
        this.connection.onPeerStateChanged = (states) => {
            if (this._isEndingCall || this._blockedSessionStart) {
                return;
            }
            const ice = states && states.iceConnectionState;
            if (!ice) {
                return;
            }
            if (ice === 'connected' || ice === 'completed') {
                if (this._iceGraceTimer) {
                    clearTimeout(this._iceGraceTimer);
                    this._iceGraceTimer = null;
                }
                if (this._isReconnectingStream) {
                    this.hideReconnectOverlay();
                    this.clearReconnectTimers();
                    this._isReconnectingStream = false;
                    this._reconnectStartedAt = null;
                    this.setState({ isReconnectingStream: false });
                }
                // Nurse peer ready — re-announce patient cam so RN shows avatar (not black)
                if (this.state.isVideoMute) {
                    this.announcePatientCameraState(true);
                }
                return;
            }
            if (ice === 'disconnected' || ice === 'failed') {
                // Hospital Wi‑Fi often blips — grace before reconnect storm
                const delay = ice === 'failed' ? 1500 : 3500;
                if (this._iceGraceTimer) {
                    clearTimeout(this._iceGraceTimer);
                }
                this._iceGraceTimer = setTimeout(() => {
                    this._iceGraceTimer = null;
                    this.beginStreamReconnect('Weak network. Reconnecting video…');
                }, delay);
            }
        };
    }

    applyHospitalSenderBitrate = (maxBitrate = 400000) => {
        try {
            const peers = this.connection && this.connection.peers;
            if (!peers) {
                return;
            }
            Object.keys(peers).forEach((pid) => {
                const peer = peers[pid] && peers[pid].peer;
                if (!peer || typeof peer.getSenders !== 'function') {
                    return;
                }
                peer.getSenders().forEach((sender) => {
                    if (!sender || !sender.track || sender.track.kind !== 'video') {
                        return;
                    }
                    const params = sender.getParameters ? sender.getParameters() : {};
                    if (!params.encodings || !params.encodings.length) {
                        params.encodings = [{}];
                    }
                    params.encodings[0].maxBitrate = maxBitrate;
                    params.encodings[0].maxFramerate = 15;
                    if (typeof sender.setParameters === 'function') {
                        sender.setParameters(params).catch(() => { });
                    }
                });
            });
        } catch (e) {
            /* ignore */
        }
    }

    /**
     * Tear down WebRTC + HTML media so Chrome Android clears the
     * "Phone speaker" / Live notification after the call ends.
     * @param {{ keepAckSpeech?: boolean }} [options]
     */
    releaseCallSession = (options = {}) => {
        const keepAckSpeech = !!(options && options.keepAckSpeech);
        // While ack voice-over is still playing, only detach live A/V —
        // do not mark the call fully ended yet (feedback / decline still pending).
        if (!keepAckSpeech) {
            this._isEndingCall = true;
        }
        this.clearReconnectTimers();
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        try {
            window.removeEventListener('beforeunload', this.handleTabClose);
            window.removeEventListener('pagehide', this.handlePageHide);
        } catch (e) {
            /* ignore */
        }
        if (this.connection && this.connection.socket) {
            try {
                this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
                this.connection.socket.off('connect', this._onRtcSocketReconnect);
            } catch (e) {
                /* ignore */
            }
        }
        releaseWebRtcCallMedia({
            mediaStream: this.mediaStream,
            connection: this.connection,
            ringAudio: this._patientRingAudio,
            stopRingTone: this.stopPatientRingTone,
            stopAckSpeech: keepAckSpeech
                ? null
                : (force) => this.stopNurseAckSpeech(force === undefined ? true : force),
        });
        this.mediaStream = null;
        this.connection = null;
        this._patientRingAudio = null;
        this._patientRingStarted = false;
    }
    getChatList = () => {
        const callBack = (response) => {
            if (response.response_code === 0) {
                this.setState({ chatList: response?.response?.ChatMessages.sort((f, s) => f?.id - s?.id) })
                return true
            }
            // Optional chat history — never kill a live emergency call on REST failure
            console.warn('chatList refresh failed; keeping call');
            return false
        }
        const params = {
            roomId: this.props.match.params.roomId,
            srm_ip_room: this.resolveSrmIpRoomFlag()
        }
        this.props.chatListAction(params, callBack)
    }
    getVirtualBackgroundList = () => {
        if (this.props.isCustomer) {
            return;
        }
        const callBack = (response) => {
            this.setState({ isLoading: false })
            if (response.response_code === 0) {
                this.setState({ virtualBackgroundImages: response?.response })
                return true
            }
            // VB is cosmetic — never end call if hospital WiFi drops this request
            console.warn('virtualBackgroundList failed; keeping call');
            return false
        }
        const params = {
            roomId: this.props.match.params.roomId,
            srm_ip_room: this.resolveSrmIpRoomFlag() || this.props.match.params.roomId
        }
        this.setState({ isLoading: true })
        this.props.virtualBackgroundListAction(params, callBack)
    }
    startVideConferencing = () => {
        const { roomId } = this.props.match.params;
        if (!this.connection) {
            return false
        }
        this.connection.socket.emit(`call_request/${this.props.attenedName?.tokenDetails?.user?.id}`, { roomId })
        this.connection.openOrJoin(roomId, (isRoomOpened, roomid, error) => {
            if (error) {
                if (error === this.connection.errors.ROOM_NOT_AVAILABLE) {
                    alert('Someone already created this room. Please either join or create a separate room.');
                    return;
                }
                alert(error);
            }

            this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
            this.attachRtcReconnectHandlers();
        });
    }

    joinVideConferencing = () => {
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        if (!this.connection) {
            return false
        }
        if (isCustomer) {
            this.connection.openOrJoin(roomId);
        } else {
            this.connection.sdpConstraints.mandatory = {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: true
            };
            this.connection.openOrJoin(roomId);
        }
        this.attachRtcReconnectHandlers();
    }

    loadVideoConferencing = () => {
        const { isCustomer } = this.props;
        ensureMediaDevicesApi();
        (function () {
            var params = {},
                r = /([^&=]+)=?([^&]*)/g;

            function d(s) {
                return decodeURIComponent(s.replace(/\+/g, ' '));
            }
            var match, search = window.location.search;
            while (match === r.exec(search.substring(1)))
                params[d(match[1])] = d(match[2]);
            window.params = params;
        })();
        // ......................................................
        // ..................RTCMultiConnection Code.............
        // ......................................................

        if (!global.RTCMultiConnection) {
            console.error('RTCMultiConnection failed to load — check /js scripts in index.html');
            if (isCustomer) {
                this.ensureCallStatusOverlay('ringing', {
                    title: 'Ringing...',
                    subtitle: 'Connecting — please wait',
                });
            }
            return;
        }

        if (typeof window !== 'undefined' && typeof window.io === 'undefined') {
            window.io = io;
        }

        this.connection = new global.RTCMultiConnection();
        // Patient hospital WiFi: keep session on brief peer blips (nurse path still auto-closes)
        this.connection.autoCloseEntireSession = !isCustomer;
        this.connection.publicRoomIdentifier = global.params.publicRoomIdentifier;

        // by default, socket.io server is assumed to be deployed on your own URL
        if (window.location.hostname === 'localhost') {
            this.connection.socketURL = SOCKET_RTC_URL;
        } else {
            this.connection.socketURL = SOCKET_RTC_URL;
        }


        // comment-out below line if you do not have your own socket.io server
        // connection.socketURL = 'https://rtcmulticonnection.herokuapp.com:443/';

        this.connection.socketMessageEvent = 'video-conference-demo';
        this.connection.session = {
            audio: true,
            video: true,
            // oneway: true
        };

        // Cap capture for hospital shared Wi‑Fi / weak cellular (patient + nurse web)
        // Soft constraints for Safari / older Android — avoid OverconstrainedError
        this.connection.mediaConstraints = {
            audio: true,
            video: {
                width: { ideal: 640 },
                height: { ideal: 480 },
                frameRate: { ideal: 15 },
            },
        };
        this.connection.bandwidth = {
            audio: 40,
            video: 400,
        };

        this.connection.sdpConstraints.mandatory = {
            OfferToReceiveAudio: true,
            OfferToReceiveVideo: true
        };

        this.connection.videosContainer = document.getElementById('videos-container');
        this.connection.onstream = (event) => {
            const isLocal = event.type === 'local';
            this.setState({
                checkIsConnected: isLocal,
                ...(isLocal ? { localStreamStarted: true } : {}),
            });
            // replaceTrack / camera switch can fire local onstream again with a new streamid; the old
            // PiP would stay and stack (looks like two fronts, one cropped/zoomed) unless we clear it.
            if (isLocal) {
                const vc = document.getElementById('videos-container');
                if (vc) {
                    vc.querySelectorAll('.media-container.front-video').forEach((node) => {
                        if (node.parentNode) {
                            node.parentNode.removeChild(node);
                        }
                    });
                }
            }
            var existing = document.getElementById(event.streamid);
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
            }

            event.mediaElement.removeAttribute('src');
            event.mediaElement.removeAttribute('srcObject');
            event.mediaElement.muted = true;
            event.mediaElement.volume = 0;

            var video = document.createElement('video');
            if (isLocal) {
                this.mediaStream = event.stream
                setTimeout(() => this.refreshVideoInputDeviceList(), 400);
                setTimeout(() => this.refreshVideoInputDeviceList(), 1500);
                // Unified Plan ignores RMC bandwidth — enforce encode cap directly
                setTimeout(() => this.applyHospitalSenderBitrate(400000), 800);
                setTimeout(() => this.applyHospitalSenderBitrate(400000), 2500);
                // Vendor Default Video ON Patient/Nurse — apply after local stream is ready
                if (this.state.isVideoMute) {
                    try {
                        this.setVideoTrackEnabled(false);
                        if (event.stream && typeof event.stream.mute === 'function') {
                            event.stream.mute('video');
                        }
                        this.announcePatientCameraState(true);
                    } catch (_e) {
                        /* ignore */
                    }
                }
            }
            try {
                video.setAttributeNode(document.createAttribute('autoplay'));
                video.setAttributeNode(document.createAttribute('playsinline'));
            } catch (e) {
                video.setAttribute('autoplay', true);
                video.setAttribute('playsinline', true);
            }
            video.autoplay = true;
            video.playsInline = true;

            if (event.type === 'local') {
                video.volume = 0;
                try {
                    video.setAttributeNode(document.createAttribute('muted'));
                } catch (e) {
                    video.setAttribute('muted', true);
                }
                video.muted = true;
                video.setAttribute('id', "canvasVideo"); //Back Streaming view
            } else {
                video.muted = false;
                video.setAttribute('id', "video"); //front Streaming View
            }
            video.srcObject = event.stream;
            let initialConnect;
            if (isLocal) {
                // After vendor-configured wait unanswered on floor nurse leg: auto-redirect to ward nurse
                clearTimeout(timmerId);
                const { floorToWardSec } = this.getEscalationSeconds();
                timmerId = setTimeout(() => {
                    const currentURL = window.location.href;
                    const srm_ip_room = localStorage.getItem("srm_ip_room");
                    const stillWaitingForNurse = this.props.isCustomer
                        && currentURL?.includes("customer")
                        && !currentURL?.includes("srm_head")
                        && !currentURL?.includes("srm_ward")
                        && srm_ip_room
                        && this.state.callPhase === 'ringing'
                        && !this._wardRedirectStarted;
                    if (!stillWaitingForNurse) {
                        return;
                    }
                    endCallListing = false;
                    this._wardRedirectStarted = true;
                    this.setState({ ip_head_redirect_model: true }, () => {
                        this.redirectToWard();
                    });
                }, floorToWardSec * 1000);
                // Customer: Ringing until agent attends (call_connect). Agent: Connecting until remote stream.
                // Skip if overlay already exists (e.g. camera switch re-fires local onstream).
                const existingOverlay = document.querySelector('#videos-container .initial-connect');
                if (!existingOverlay && this.state.callPhase !== 'connected') {
                    const phase = this.state.callPhase;
                    const showConnecting = !isCustomer || phase === 'connecting';
                    const statusTitle = showConnecting ? 'Connecting...' : 'Ringing...';
                    const statusSubtitle = showConnecting
                        ? (this.state.agentName
                            ? `Connecting with ${this.state.agentName}`
                            : 'Establishing video connection')
                        : 'Waiting for Nurse to answer';
                    if (!isCustomer && phase === 'ringing') {
                        this.setState({ callPhase: 'connecting' });
                    }
                    // Duration starts when remote patient stream arrives — not on local preview
                    initialConnect = document.createElement('div');
                    initialConnect.className = `initial-connect call-phase-${showConnecting ? 'connecting' : 'ringing'}`;
                    initialConnect.insertAdjacentHTML('beforeend', `
                    <div class="call-status-box">
                        <div class="call-status-avatar" aria-hidden="true"${showConnecting ? ' style="display:none"' : ''}><i class="fa-solid fa-user-nurse"></i></div>
                        <h1 class="call-status-title">${statusTitle}</h1>
                        <p class="call-status-subtitle">${statusSubtitle}</p>
                        <div class="call-status-icon">${showConnecting ? this.getCallStatusIconHtml(true) : ''}</div>
                    </div>
                    `);
                    document.querySelector('#videos-container').appendChild(initialConnect)
                }
            } else {
                this.removeCallStatusOverlay();
                this.hideReconnectOverlay();
                clearTimeout(timmerId)
                // Nurse peer present — re-send patient camera state (early mute was often dropped)
                if (this.state.isVideoMute) {
                    this.announcePatientCameraState(true);
                }
                // Fallback: if nurse disables track without signaling, still show camera-off UI
                this.attachRemoteVideoMuteListeners(event.stream);
                // Nurse camera-off UI only when vendor default says nurse starts OFF
                if (isCustomer && !readDefaultVideoOnNurse()) {
                    if (!this._nurseCamConfirmedOn) {
                        this.applyRemoteCameraOff(true);
                    }
                } else if (isCustomer && readDefaultVideoOnNurse()) {
                    this._nurseCamConfirmedOn = true;
                    this.applyRemoteCameraOff(false);
                } else if (this._pendingRemoteCamOff) {
                    setTimeout(() => this.applyRemoteCameraOff(true), 50);
                }
            }

            var width = parseInt(this.connection.videosContainer.clientWidth / 3) - 20;
            var mediaElement = global.getHTMLMediaElement(video, {
                title: '',
                buttons: [],
                width: width,
                showOnMouseEnter: false
            }, isLocal, isCustomer);

            this.connection.videosContainer.appendChild(mediaElement);
            const streamMedia = mediaElement.media || video;
            if (streamMedia) {
                // Single play path — avoid onloadedmetadata + timeout double-play (AbortError)
                const tryPlay = () => this.playStreamSafely(streamMedia);
                if (streamMedia.readyState >= 2) {
                    tryPlay();
                } else {
                    streamMedia.onloadedmetadata = tryPlay;
                    streamMedia.oncanplay = tryPlay;
                    setTimeout(tryPlay, 400);
                }
            }

            mediaElement.id = event.streamid;

            if (event.type === 'local') {
                this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
                this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
                this.attachRtcReconnectHandlers();
            }
            // Enable WhatsApp-style tap-to-swap once both tiles exist
            setTimeout(() => this.bindVideoSwapClick(), 100);
            setTimeout(() => this.refreshVideoSwapTargets(), 150);
        };

        this.connection.onCustomMsg = (msg) => {
            this.setState({ connnectionMessage: msg })
            const { isVirtualBackground, isScreenView } = this.state
            const camOff = cameraSignalPolicy.resolveNurseRemoteCameraOff(msg, this.connection?.userid);
            if (camOff === null) {
                return;
            }
            if (!camOff) {
                this._nurseCamConfirmedOn = true;
            } else {
                this._nurseCamConfirmedOn = false;
            }
            this.applyRemoteCameraOff(camOff, { isVirtualBackground, isScreenView });
        };

        // RMC mute — ONLY remote nurse stream (local patient mute must not hide nurse)
        this.connection.onmute = (e) => {
            const camOff = cameraSignalPolicy.shouldApplyRmcRemoteVideoMute(e, 'mute');
            if (camOff === null) {
                return;
            }
            this._nurseCamConfirmedOn = false;
            this.applyRemoteCameraOff(true);
        };
        this.connection.onunmute = (e) => {
            const camOff = cameraSignalPolicy.shouldApplyRmcRemoteVideoMute(e, 'unmute');
            if (camOff === null) {
                return;
            }
            this._nurseCamConfirmedOn = true;
            this.applyRemoteCameraOff(false);
        };

        this.connection.onstreamended = (event) => {
            var mediaElement = document.getElementById(event.streamid);
            if (mediaElement) {
                mediaElement.parentNode.removeChild(mediaElement);
            }
        };

        this.connection.onMediaError = (e) => {
            if (e.message === 'Concurrent mic process limit.') {
                if (global.DetectRTC.audioInputDevices.length <= 1) {
                    alert('Please select external microphone. Check github issue number 483.');
                    return;
                }

                var secondaryMic = global.DetectRTC.audioInputDevices[1].deviceId;
                this.connection.mediaConstraints.audio = {
                    deviceId: secondaryMic
                };

                this.connection.join(this.connection.sessionid);
                return;
            }

            // Patient denied/blocked camera or mic on call page
            const msg = String(e?.message || e?.name || e || '');
            const denied = /NotAllowed|PermissionDenied|Permission denied|NotAllowedError/i.test(msg)
                || e?.name === 'NotAllowedError'
                || e?.name === 'PermissionDeniedError';
            if (isCustomer && denied) {
                this._mediaPermissionBlocked = true;
                this.setState({ mediaPermissionBlocked: true });
                this.ensureCallStatusOverlay('ringing', {
                    title: 'Allow camera',
                    subtitle: 'Tap Allow when asked, then tap Try again.',
                    showLoader: false,
                    showMediaRetry: true,
                });
                return;
            }
        };

        if (!!global.params.password) {
            this.connection.password = global.params.password;
        }

        // detect 2G
        if (navigator.connection &&
            navigator.connection.type === 'cellular' &&
            navigator.connection.downlinkMax <= 0.115) {
            alert('2G is not supported. Please use a better internet service.');
        }
        canvas = document.getElementById("canvas");
        this.joinVideConferencing()
    }

    //Function to trigger call end api by checking the isCustomer
    confirmEndCall = () => {
        this.setState({ showEndCallConfirm: false }, () => this.endCall());
    };

    endCall = (isSocket) => {
        // Nurse ended via ack — keep patient UI until English+Tamil voice-over completes,
        // but still stop live call media so Android clears the Phone speaker notification.
        if (this.shouldWaitForAckVoice()) {
            this._pendingEndAfterAckVoice = true;
            this.releaseCallSession({ keepAckSpeech: true });
            return false;
        }
        this.stopPatientRingTone();
        this.setState({ showEndCallConfirm: false });
        const { isCustomer } = this.props;
        if (isSocket) {
            if (isCustomer && (!endCallListing || this._headRedirectInProgress || this._headRedirectStarted || this._wardRedirectInProgress || this._wardRedirectStarted)) {
                return false;
            }
            // Always drop beforeunload leave-prompt before closing the agent tab
            this.releaseCallSession();
            if (isCustomer) {
                const roomId = this.props.match.params.roomId;
                PatientCallSession.markClosed(roomId);
            }
            return false;
        }
        this.releaseCallSession();
        this.setState({ isLoading: true })
        if (isCustomer) {
            const params = this.buildPatientEndCallParams();
            this.props.customerDeclineAction(params, (res) => {
                this.setState({ isLoading: false })
                this.goToPatientFeedback();
            })
        }
        else {
            let params = {
                roomId: this.props.match.params.roomId,
                callStatus: 3,
                isActive: false,
                callEndTime: new Date().getTime(),
                isSrmIpAgent: this.state.isSrmIpAgent
            }
            const declinecallback = (response) => {
                this.setState({ isLoading: false })
                if (!isCustomer) {
                    window.close()
                } else {
                    this.goToPatientFeedback();
                }
            }
            this.props.updateAppointment(params, declinecallback)
        }
        // this.props.customerDeclineAction(params, (res) => {
        //     if (res.response.status !== 500) {
        //         this.connection.close();
        //         if (isCustomer) {
        //             this.props.history.push('/customer');
        //             setTimeout(() => {
        //                 window.location.reload();
        //             }, 200)
        //         } else {
        //             window.close();
        //         }
        //         if (isSocket) {
        //             return false
        //         }
        //         const { roomId } = this.props.match.params;
        //         let data = {
        //             customer: !!isCustomer
        //         }
        //         const requestOptions = {
        //             method: 'POST',
        //             headers: { 'Content-Type': 'application/json' },
        //             body: JSON.stringify({ url: `endcall/${roomId}/${isCustomer ? 'customer' : 'store'}`, data })
        //         };

        //         fetch(`${this.socketURL}/api/socket`, requestOptions)
        //             .then((res) => res.json())
        //             .then(data => {
        //             })
        //     }
        //     else {
        //         return false;
        //     }
        // })

    }

    handleChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value })
    }

    handleKeyUp = (e) => {
        if (e.keyCode === 13) {
            this.sendMessage()
        }
    }

    sendMessage = () => {
        const role = this.props.getTokenDetails?.LOGIN_CREDS?.tokenDetails?.user?.roleId
        const user = this.props.getTokenDetails?.LOGIN_CREDS?.tokenDetails?.user?.id
        let { message, chat } = this.state;
        if (message) {
            const { roomId } = this.props.match.params;
            let data;
            if (!this.props.isCustomer) {
                data = {
                    message,
                    roleId: role,
                    roomId,
                    userId: user
                }
            } else {
                data = {
                    message,
                    roleId: this.props.getCustomerToken?.roleId,
                    roomId,
                    userId: this.props.getCustomerToken?.id
                }
            }

            chat.push(data)
            const callBack = (response) => {
                if (response.response_code === 0) {
                    let arrayList = []
                    arrayList = this.props.getChatListAction
                    arrayList.push(response?.response?.ChatMessages)
                    this.props.socketAppendChatAction(arrayList)
                }
            }
            this.props.addChatListAction(data, callBack)
        }
        this.setState({ message: '', chat })
    }
    openApp() {
        window.open(`https://${SHOPPING_DOMAIN}`, "_blank")
    }
    openLink(link) {
        window.open(link, "_blank")
    }

    onMute = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            this.setState({ isMute: true })
            this.mediaStream && this.mediaStream.mute('audio')
        }
    }
    onUnMute = () => {
        this.setState({ isMute: false })
        this.mediaStream && this.mediaStream.unmute('audio')
    }

    setVideoTrackEnabled = (enabled) => {
        if (!this.mediaStream || typeof this.mediaStream.getVideoTracks !== 'function') {
            return;
        }
        this.mediaStream.getVideoTracks().forEach((track) => {
            track.enabled = enabled;
        });
    }

    clearPatientCamAnnounceTimers = () => {
        if (Array.isArray(this._patientCamAnnounceTimers) && this._patientCamAnnounceTimers.length) {
            this._patientCamAnnounceTimers.forEach((t) => clearTimeout(t));
        }
        this._patientCamAnnounceTimers = [];
    }

    /**
     * Nurse RN ignores RMC StreamsHandler — emit explicit patientCameraState only
     * (never piggyback mic mute). Retries until nurse peer is listening.
     */
    announcePatientCameraState = (muted) => {
        const emitOnce = () => {
            try {
                const socket = this.connection?.socket;
                if (!socket || typeof socket.emit !== 'function') {
                    return;
                }
                const roomId = this.connection?.sessionid || this.state.roomId;
                let participants = [];
                try {
                    participants = (this.connection.getAllParticipants && this.connection.getAllParticipants()) || [];
                } catch (_e) {
                    participants = [];
                }
                const targets = [...new Set([...(participants || []), roomId].filter(Boolean))];
                if (!targets.length) {
                    return;
                }
                const sender = this.connection.userid;
                // Video-only payloads — do not send audio streamSyncNeeded here
                const message = {
                    type: 'video',
                    action: muted ? 'mute' : 'unmute',
                    cameraOff: !!muted,
                    patientCameraState: true,
                };
                targets.forEach((targetId) => {
                    socket.emit('video-conference-demo', {
                        remoteUserId: targetId,
                        sender,
                        message,
                    });
                });
            } catch (_e) {
                /* ignore */
            }
        };

        emitOnce();
        this.clearPatientCamAnnounceTimers();
        const mutedSnapshot = !!muted;
        [400, 1200, 2500].forEach((ms) => {
            const timer = setTimeout(() => {
                if (!!this.state.isVideoMute === mutedSnapshot) {
                    emitOnce();
                }
            }, ms);
            this._patientCamAnnounceTimers.push(timer);
        });
    };

    onMuteVideo = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            const { isCustomer } = this.props
            this.setState({ isVideoMute: true, isVrBackgroundIcon: false })
            this.setVideoTrackEnabled(false)
            this.mediaStream && this.mediaStream.mute('video')
            this.announcePatientCameraState(true)
            this.handleAvatatOnMute();
            if (!isCustomer && this.state.virtualBackgroundSelectId) {
                clearInterval(backgroundInterval)
            }
        }
    }
    onUnMuteVideo = () => {
        const { isCustomer } = this.props
        this.setState({ isVideoMute: false })
        this.setVideoTrackEnabled(true)
        this.mediaStream && this.mediaStream.unmute('video')
        this.announcePatientCameraState(false)
        this.handleAvatatOnUnMute();
        if (!isCustomer && this.state.virtualBackgroundSelectId && this.state.vbOption === 2) {
            this.setIntervalForAutoChangeBackground(0, this.state.virtualBackgroundImages)
        }
    }

    onStartScreenShare = () => {
        const screenRoomId = uuidv4();
        this.setState({ screenRoomId, isScreenShared: true });
    }
    takePicture = () => {
        let video = document.getElementById("video")
            || document.querySelector('#videos-container .media-container.background-video video');
        const output = document.getElementById('capture-img')
        canvas = document.getElementById("canvas") || canvas;
        if (!video || !output || !canvas || !video.videoWidth) {
            return;
        }
        const context = canvas.getContext("2d");
        height = video.videoHeight / (video.videoWidth / width)
        if (isNaN(height)) {
            height = width / (4 / 3);
        }
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);
        if (width && height) {
            context.drawImage(video, 0, 0, width, height);
            const data = canvas.toDataURL("image/png")
            const existing = document.getElementById("photo");
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
            }
            let img = document.createElement("img")
            img.id = 'photo'
            img.alt = "The screen capture will appear in this box."
            img.setAttribute("src", data);
            console.log("Capture Image base64", data);
            this.setState({ verificationImage: data })
            output.appendChild(img)
        }
    }
    onCaptureButtonOpen = () => {
        this.setState({ isCaptureButton: true }, () => {
            this.takePicture()
        });
    }
    onScreenShared = (screenRoomId) => {
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        let params = {
            roomId,
            stop: false,
            isCustomer: !!isCustomer,
            screenRoomId: this.state.screenRoomId,
            srm_ip_room: this.resolveSrmIpRoomFlag(),
        }
        this.props.screenShareAction(params, (res) => {
        })
        // const requestOptions = {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ url: `screen/${roomId}/${isCustomer ? 'customer' : 'store'}`, data })
        // };
        // fetch(`${this.socketURL}/api/socket`, requestOptions)
        //     .then(response => response.json())
        //     .then(data => {
        //     });
    }

    onStopScreenShare = () => {
        if (!this.state.isScreenShared) {
            return;
        }
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        let params = {
            roomId,
            stop: true,
            isCustomer: !!isCustomer
        }
        this.props.updateScreenShareAction(params)
        this.setState({ screenRoomId: '', isScreenShared: false });
    }

    removePicture = () => {
        let captureContainer = document.getElementById('capture-img')
        let captureImage = document.getElementById("photo")
        captureContainer.removeChild(captureImage)
    }
    onCaptureButtonClose = () => {
        this.setState({ isCaptureButton: false }, () => {
            this.removePicture()
        })
    }
    repeatPicture = () => {
        this.removePicture()
        this.takePicture()
    }
    handleChat = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            this.setState({ isChatOpened: !this.state.isChatOpened, unreadMessageCount: 0 })
            this.getChatList()
            if (this.state.isVrBackgroundIcon) {
                this.setState({ isVrBackgroundIcon: false })
            }
        }
    }
    handleBackground = (e, check) => {
        if (this.state.isVideoMute && this.state.virtualBackgroundSelectId === 0) {
            toast.warning("Please Turn on your Camera")
        } else {
            this.setState({ isVrBackgroundIcon: !this.state.isVrBackgroundIcon }) // virtual background popup open and close
            if (this.state.isChatOpened) {
                this.setState({ isChatOpened: false }) // if chat popup is opend that time open the virtual background means only colse the chat popup
            }
        }
    }
    handleAvatatOnMute = () => {
        const { isVirtualBackground } = this.state;
        const { isCustomer } = this.props;
        // Clear any legacy DOM avatars; React camera-off tile handles UI
        document.querySelectorAll('.inner-media-box').forEach((el) => {
            if (el.parentElement) {
                el.parentElement.removeChild(el);
            }
        });
        const localVideo = document.getElementById('canvasVideo');
        if (localVideo) {
            localVideo.style.visibility = 'hidden';
        }
        if (isVirtualBackground && !isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'none';
            }
        }
    }
    handleAvatatOnUnMute = () => {
        const { isVirtualBackground } = this.state;
        const { isCustomer } = this.props;
        document.querySelectorAll('.inner-media-box').forEach((el) => {
            if (el.parentElement) {
                el.parentElement.removeChild(el);
            }
        });
        const localVideo = document.getElementById('canvasVideo');
        if (localVideo) {
            localVideo.style.visibility = '';
            localVideo.style.display = 'block';
        }
        if (isVirtualBackground && !isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'block';
            }
        } else if (!isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'none';
            }
        }
    }
    ageVerification = () => {
        const { roomId } = this.props.match.params;
        const { verificationImage } = this.state
        this.setState({ isLoading: true })
        let img = verificationImage.substring(verificationImage.indexOf(",") + 1);
        let params = {
            roomId: roomId,
            imageUrl: img,
            srm_ip_room: this.resolveSrmIpRoomFlag(),
        }
        this.props.ageVerification(params, (res) => {
            this.setState({ isLoading: false })
            if (res?.response?.data?.response_code === 2) {
                toast.error("OCR Server down")
            }
        })
    }
    setIntervalForAutoChangeBackground = (index, virtualBackgroundImages) => {
        if (virtualBackgroundImages.length > 0) {
            backgroundInterval = setInterval(() => {
                if ((virtualBackgroundImages.length - 1) === index) {
                    index = 0;
                } else {
                    index += 1;
                }
                let img = virtualBackgroundImages[index]
                let findDinamicImgDiv = document.getElementsByClassName("dinamicImgDivRender")
                if (findDinamicImgDiv.length > 0) {
                    document.querySelector('#videos-container').removeChild(findDinamicImgDiv[0])
                }
                let createDinamicImg = document.createElement('div');
                createDinamicImg.className = "dinamicImgDivRender"
                createDinamicImg.innerHTML = `<img id='vbackground_${img?.id}' src=${this.setImg(img?.id, img?.imageURL)} alt="dinamic" />`
                document.querySelector('#videos-container').appendChild(createDinamicImg)
                let imgTag = document.getElementById(`vbackground_${img?.id}`)
                imgTag.setAttribute("style", 'display: none')
                if (this.state.virtualBackgroundSelectId && !this.state.isVideoMute) {
                    this.setVideo(imgTag, img.id, false)
                }
            }, 15000);  // 15 sec once virtual background auto change.
        }
    }
    autoChangeBackground = (e, imageIndex, index, virtualBackgroundImages) => {
        clearInterval(backgroundInterval)
        const { isCustomer } = this.props;
        if (this.state.isVideoMute && !isCustomer) {
            return toast.warning("Please Turn on your Camera")
        }
        if (imageIndex != 0) {
            if (this.state.vbOption === 2) {
                this.setIntervalForAutoChangeBackground(index, virtualBackgroundImages)
            }
        }
        this.setVideo(e, imageIndex, true)
    }

    setVideo = (e, imageIndex, loading) => {
        const { isCustomer } = this.props;
        if (this.state.isVideoMute && !isCustomer) {
            return toast.warning("Please Turn on your Camera")
        }
        this.setState({ virtualBackgroundSelectId: imageIndex })
        if (loading) {
            this.setState({ isLoading: true, })
        }
        if (imageIndex == 0) {
            clearInterval(backgroundInterval)
            if (this.state.isVirtualBackground) {
                this.setState({ isVirtualBackground: false, isVirtualBackgroundIMG: e })
                let frontVideo = document.getElementById("canvasVideo")
                if (!isCustomer) {
                    let fronendCanvas = document.getElementById("frCanvas")
                    frontVideo.setAttribute("style", "display: block")
                    fronendCanvas.setAttribute("style", "display:none")
                    this.virtualBackgroundSet(frontVideo, false)
                } else {
                    let backVideo = document.getElementById("video")
                    let backgroundCanvas = document.getElementById("bgCanvas")
                    backVideo.setAttribute("style", "display:block");
                    backgroundCanvas.setAttribute("style", "display:none")
                    this.setState({ isLoading: false })
                    this.virtualBackgroundSet(backVideo, false)
                }
                if (!isCustomer) {
                    const { roomId } = this.props.match.params;
                    let params = {
                        roomId: roomId,
                        id: imageIndex,
                        srm_ip_room: this.resolveSrmIpRoomFlag(),
                        isSrmIpAgent: this.state.isSrmIpAgent
                    }
                    this.props.vbImage(params, (res) => {
                        this.setState({ isLoading: false })
                        if (res?.response?.data?.response_code === 2) {
                            toast.error(res?.response?.data?.response_message)
                        }
                    })
                }
            } else {
                this.setState({ isLoading: false })
            }
        } else {
            this.setState({ isVirtualBackground: true, isVirtualBackgroundIMG: e })
            const { isCustomer } = this.props;
            let frontVideo = document.getElementById("canvasVideo")
            if (isCustomer) {
                let backVideo = document.getElementById("video")
                let backgroundCanvas = document.getElementById("bgCanvas")
                if (this.state.isScreenView) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;")
                } else {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto")
                }
                backVideo.setAttribute("style", "display: none")
                this.canvasRef.current = backgroundCanvas
                this.virtualBackgroundSet(backVideo, true)
                this.setState({ isLoading: false })
            }
            else {
                let fronendCanvas = document.getElementById("frCanvas")
                fronendCanvas.setAttribute("style", "display:block")
                frontVideo.setAttribute("style", "visibility: hidden;position: absolute;")
                this.canvasRef.current = fronendCanvas
                this.virtualBackgroundSet(frontVideo, true)
            }
            if (!isCustomer) {
                const { roomId } = this.props.match.params;
                let params = {
                    roomId: roomId,
                    id: imageIndex,
                    srm_ip_room: this.resolveSrmIpRoomFlag(),
                }
                this.props.vbImage(params, (res) => {
                    this.setState({ isLoading: false })
                    if (res?.response?.data?.response_code === 2) {
                        toast.error(res?.response?.data?.response_message)
                    }
                })
            }
        }

    }
    zoomIn = () => {
        const { isCustomer } = this.props;
        this.setState({ isZoom: true }, () => this.refreshMainVideoAfterZoom());
        if (this.state.isVirtualBackground && isCustomer) {
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (backgroundCanvas) {
                backgroundCanvas.style.objectFit = 'cover';
                this.canvasRef.current = backgroundCanvas
            }
        }
    }
    zoomOut = () => {
        const { isCustomer } = this.props;
        this.setState({ isZoom: false }, () => this.refreshMainVideoAfterZoom());
        if (this.state.isVirtualBackground && isCustomer) {
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (backgroundCanvas) {
                backgroundCanvas.style.objectFit = 'cover';
                this.canvasRef.current = backgroundCanvas
            }
        }
    }

    /** After zoom layout change, force main video to keep painting (avoids black screen). */
    refreshMainVideoAfterZoom = () => {
        const container = document.getElementById('videos-container');
        if (!container) {
            return;
        }
        const isSwapped = container.classList.contains('video-swapped');
        const mainSel = isSwapped
            ? '.media-container.front-video video, .media-container.front-video #frCanvas'
            : '.media-container.background-video video, .media-container.background-video #bgCanvas';
        container.querySelectorAll(mainSel).forEach((el) => {
            try {
                el.style.objectFit = 'cover';
                el.style.objectPosition = 'center center';
                el.style.width = '100%';
                el.style.height = '100%';
                el.style.visibility = 'visible';
                el.style.opacity = '1';
                el.style.display = 'block';
                if (el.tagName === 'VIDEO') {
                    // Re-assigning the same srcObject interrupts play() → AbortError; only play if paused.
                    if (el.paused) {
                        this.playStreamSafely(el);
                    }
                }
            } catch (e) {
                /* ignore */
            }
        });
    }
    changeVbOption = (e) => {
        if (e.target.value == 1) {
            this.setState({ vbOption: 2 })
            if (this.state.isVirtualBackground) {
                this.setIntervalForAutoChangeBackground(0, this.state.virtualBackgroundImages)
            }
        } else {
            this.setState({ vbOption: 1 })
            clearInterval(backgroundInterval)
        }
    }
    redirectToWard = () => {
        if (this._wardRedirectInProgress) {
            return;
        }
        const { mapping, encryptRoomId, wardUserId } = this.getWardRedirectContext();
        if (!mapping?.srmIpServiceId || !mapping?.srmIpRoomId || !encryptRoomId) {
            toast.error('Unable to redirect call. Please try again.');
            this._wardRedirectStarted = false;
            this.setState({ ip_head_redirect_model: false });
            return;
        }
        // No Ward Nurse assigned → skip wait and go to Head Nurse immediately.
        if (!wardUserId) {
            this._wardRedirectStarted = false;
            this._headRedirectStarted = true;
            this.setState({ ip_head_redirect_model: true }, () => {
                this.redirectToHead();
            });
            return;
        }
        this._wardRedirectInProgress = true;
        endCallListing = false;
        this.setState({ isLoading: true, ip_head_redirect_model: true })
        const { isCustomer } = this.props;
        const callBack = (res) => {
            const params = {
                encryptRoomId: encryptRoomId,
                srmIpServiceId: mapping.srmIpServiceId,
                srmIpRoomId: mapping.srmIpRoomId,
                userId: wardUserId,
                isWardEscalation: 1,
                srmCallSessionId: localStorage.getItem('srm_call_session_id'),
            }
            this.props.customerListAction(params, (res) => {
                this.setState({ isLoading: false })
                if (res?.response_code === 0) {
                    const roomId = res?.response?.roomId
                    endCallListing = true
                    try {
                        this.connection && this.connection.close && this.connection.close();
                    } catch (e) {
                        /* ignore */
                    }
                    this._wardRedirectInProgress = false;
                    this.setState({ ip_head_redirect_model: false, isLoading: false });
                    if (res?.response?.busyRedirectMessage) {
                        toast.info(res.response.busyRedirectMessage, { autoClose: 6000 });
                    }
                    const tier = String(res?.response?.srmEscalationTier || 'ward').toLowerCase();
                    if (tier === 'head') {
                        this.updateCallStatusOverlay('Ringing...', 'Waiting for Head Nurse to answer');
                        this.props.history.replace('/srm_head/' + roomId)
                    } else {
                        this.updateCallStatusOverlay('Ringing...', 'Waiting for Ward Nurse to answer');
                        this.props.history.replace('/srm_ward/' + roomId)
                    }
                } else {
                    this._wardRedirectInProgress = false
                    this._wardRedirectStarted = false
                    endCallListing = true
                    this.setState({ ip_head_redirect_model: false })
                    toast.error(typeof res?.response === 'string' ? res.response : 'Unable to connect Ward Nurse.')
                    if (!isCustomer) {
                        window.close()
                    } else {
                        this.goToPatientFeedback();
                    }
                }
            })
        }
        const params = this.buildPatientEndCallParams({ reason: 'not_answered' });
        this.props.customerDeclineAction(params, callBack)
    }
    redirectToHead = () => {
        if (this._headRedirectInProgress) {
            return;
        }
        const { mapping, encryptRoomId, headUserId } = this.getHeadRedirectContext();
        if (!mapping?.srmIpServiceId || !mapping?.srmIpRoomId || !encryptRoomId) {
            toast.error('Unable to redirect call. Please try again.');
            this._headRedirectStarted = false;
            this.setState({ ip_head_redirect_model: false });
            return;
        }
        if (!headUserId) {
            toast.error('Service head is not configured for this service.');
            this._headRedirectStarted = false;
            this.setState({ ip_head_redirect_model: false });
            return;
        }
        this._headRedirectInProgress = true;
        endCallListing = false;
        this.setState({ isLoading: true, ip_head_redirect_model: true })
        const { isCustomer } = this.props;
        const callBack = (res) => {
            const params = {
                encryptRoomId: encryptRoomId,
                srmIpServiceId: mapping.srmIpServiceId,
                srmIpRoomId: mapping.srmIpRoomId,
                userId: headUserId,
                isHeadEscalation: 1,
                srmCallSessionId: localStorage.getItem('srm_call_session_id'),
            }
            this.props.customerListAction(params, (res) => {
                this.setState({ isLoading: false })
                if (res?.response_code === 0) {
                    const roomId = res?.response?.roomId
                    endCallListing = true
                    try {
                        this.connection && this.connection.close && this.connection.close();
                    } catch (e) {
                        /* ignore */
                    }
                    this._headRedirectInProgress = false;
                    this.setState({ ip_head_redirect_model: false, isLoading: false });
                    if (res?.response?.busyRedirectMessage) {
                        toast.info(res.response.busyRedirectMessage, { autoClose: 6000 });
                    }
                    this.updateCallStatusOverlay('Ringing...', 'Waiting for Head Nurse to answer');
                    this.props.history.replace('/srm_head/' + roomId)
                } else {
                    this._headRedirectInProgress = false
                    this._headRedirectStarted = false
                    this._wardRedirectStarted = false
                    endCallListing = true
                    this.setState({ ip_head_redirect_model: false })
                    toast.error(typeof res?.response === 'string' ? res.response : 'Unable to connect Head Nurse.')
                    if (!isCustomer) {
                        window.close()
                    } else {
                        this.goToPatientFeedback();
                    }
                }
            })
        }
        const params = this.buildPatientEndCallParams({ reason: 'not_answered' });
        this.props.customerDeclineAction(params, callBack)
    }
    render() {
        const { isCustomer, attenedName } = this.props;
        const { isChatOpened, message, customerName, agentName, isMute, avatarmain, isVideoMute, unreadMessageCount = 0, isZoom, isScreenShared, isCaptureButton, isScreenView, screenRoomId, checkIsConnected, isLoading, isMobileDevice, isVrBackgroundIcon, virtualBackgroundSelectId, isVirtualBackground, virtualBackgroundImages, vbOption, isSwitchingCamera, localStreamStarted, canSwitchCamera, showCallDuration, callDurationDisplay, showEndCallConfirm, isVideoSwapped } = this.state;
        const chatList = this.props.getChatListAction;
        // const { isLoading } = this.props.customerDeclineLoader;
        // const { appointmentLoading } = this.props.updateAppointmentLoader;
        const { cartGeneration } = attenedName
        return (
            <div className="customer-care-call" id="chat-page">
                {this.state.ip_head_redirect_model && (
                    <div className="alert-style">
                        <div className="alert d-flex flex-column align-items-center" role="alert">
                            <div className="call-status-avatar mb-3" style={{ width: 72, height: 72, fontSize: '1.75rem' }}>
                                <i className="fa-solid fa-user-nurse" aria-hidden="true"></i>
                            </div>
                            <div className="nurse-popup-desc mb-3">
                                {window.location.pathname.includes('/srm_head/')
                                    ? 'Call redirecting to Head Nurse… Please wait.'
                                    : window.location.pathname.includes('/srm_ward/')
                                        ? 'Call redirecting to Ward Nurse… Please wait.'
                                        : 'Connecting you to the next available nurse… Please wait.'}
                            </div>
                            <div className="nurse-spinner" aria-hidden="true"><span></span><span></span><span></span></div>
                        </div>
                    </div>
                )}
                {showEndCallConfirm && (
                    <div className="nurse-popup-overlay" role="dialog" aria-modal="true">
                        <div className="nurse-popup-card">
                            <h3 className="nurse-popup-title">Warning</h3>
                            <p className="nurse-popup-desc">Are you sure you want to end the call?</p>
                            <div className="nurse-popup-actions">
                                <button type="button" className="nurse-btn nurse-btn-secondary" onClick={() => this.setState({ showEndCallConfirm: false })}>
                                    Cancel
                                </button>
                                <button type="button" className="nurse-btn nurse-btn-danger" onClick={() => this.confirmEndCall()}>
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {(isLoading) && <AppLoader />}
                <div className="customer-care-call-content">
                    <div className="row bc-black">
                        <div className={`col-12 ${(isChatOpened || isVrBackgroundIcon) ? 'chat-open col-lg-9' : 'col-md-12'} p-0`} id="video-hide">
                            <div
                                id="videos-container"
                                className={`${!isZoom ? 'max-video' : ''} ${isScreenView ? 'video-screen' : ''} ${isScreenShared ? 'is-screen-sharing' : ''} ${isVideoSwapped ? 'video-swapped' : ''} ${avatarmain ? 'remote-cam-off' : ''} ${isVideoMute ? 'local-cam-off' : ''}`.trim()}
                            >
                                {isScreenShared && (
                                    <div className="screen-sharing-badge" aria-live="polite">
                                        You are sharing your screen
                                    </div>
                                )}
                                {showCallDuration && (
                                    <div className="call-duration-badge" aria-live="polite">
                                        {callDurationDisplay}
                                    </div>
                                )}
                                {/* Original left-corner Zoom In / Out — full size vs fit-to-device */}
                                {!isScreenView && (
                                    <>
                                        {!isZoom && (
                                            <div className="zoom-icon zoomInTooltip" title="Zoom In" onClick={() => this.zoomIn()}>
                                                <i className="fas fa-expand-arrows-alt"></i>
                                            </div>
                                        )}
                                        {isZoom && (
                                            <div className="zoom-icon zoomOutTooltip" title="Zoom Out" onClick={() => this.zoomOut()}>
                                                <i className="fas fa-compress-arrows-alt"></i>
                                            </div>
                                        )}
                                    </>
                                )}
                                {(avatarmain && !isScreenView) && (
                                    <div
                                        className={`camera-off-tile camera-off-remote ${isVideoSwapped ? 'is-pip' : 'is-main'}`}
                                        onClick={isVideoSwapped ? (e) => { e.stopPropagation(); this.toggleVideoSwap(); } : undefined}
                                        role={isVideoSwapped ? 'button' : undefined}
                                        title={isVideoSwapped ? 'Tap to swap' : undefined}
                                    >
                                        <div className="camera-off-icon" aria-hidden="true">
                                            <i className="fa-solid fa-video-slash"></i>
                                        </div>
                                        <div className="camera-off-avatar" aria-hidden="true">
                                            {this.getNameInitial(isCustomer ? (agentName || 'Nurse') : customerName, isCustomer ? 'N' : 'C')}
                                        </div>
                                        <p className="camera-off-label">Camera is off</p>
                                    </div>
                                )}
                                {(isVideoMute && !isScreenView) && (
                                    <div
                                        className={`camera-off-tile camera-off-local ${isVideoSwapped ? 'is-main' : 'is-pip'}`}
                                        onClick={!isVideoSwapped ? (e) => { e.stopPropagation(); this.toggleVideoSwap(); } : undefined}
                                        role={!isVideoSwapped ? 'button' : undefined}
                                        title={!isVideoSwapped ? 'Tap to swap' : undefined}
                                    >
                                        <div className="camera-off-icon" aria-hidden="true">
                                            <i className="fa-solid fa-video-slash"></i>
                                        </div>
                                        <div className="camera-off-avatar" aria-hidden="true">
                                            {this.getNameInitial(isCustomer ? (customerName || 'You') : (agentName || 'Nurse'), isCustomer ? 'Y' : 'N')}
                                        </div>
                                        <p className="camera-off-label">Camera is off</p>
                                    </div>
                                )}
                                <div className="d-flex justify-content-center  customer-end-call-content icons">
                                    {isMute ? (<div className="cuatomer-call-circle-slash mx-3 OnMuteIcon unMuteMicTooltip" title="UnMute Mic" onClick={() => this.onUnMute()}>
                                        <i className="fa-solid fa-microphone-slash mic-icon-slash"></i>
                                    </div>) :
                                        (<div className="cuatomer-call-circle mx-3 OnMuteIcon" title="Mute Mic" onClick={(e) => this.onMute(e, checkIsConnected)}>
                                            <i className="fa-solid fa-microphone mic-icon muteMicTooltip" ></i>
                                        </div>)}
                                    {isVideoMute ? (<div className="cuatomer-call-circle-slash mx-3 OnVideoMute unMuteVideoTooltip" title="Un Mute Video" onClick={() => this.onUnMuteVideo()}>
                                        <i className="fa-solid fa-video-slash mic-icon-slash" ></i>
                                    </div>) :
                                        (<div className="cuatomer-call-circle mx-3 OnVideoMute muteVideoTooltip" title="Mute Video" onClick={(e) => this.onMuteVideo(e, checkIsConnected)}>
                                            <i className="fa-solid fa-video-camera mic-icon"></i>
                                        </div>)}
                                    {localStreamStarted && canSwitchCamera && (
                                        <div
                                            className={`cuatomer-call-circle mx-3 switchCameraTooltip${isSwitchingCamera ? ' pe-none opacity-50' : ''}`}
                                            title="Switch camera"
                                            onClick={() => !isSwitchingCamera && this.switchCamera()}
                                        >
                                            <i className="fa-solid fa-camera-rotate mic-icon"></i>
                                            <Tooltip anchorSelect=".switchCameraTooltip" place="top">
                                                Switch camera
                                            </Tooltip>
                                        </div>
                                    )}
                                    <div className="cuatomer-call-circle mx-3 OnEndCall endCallTooltip" title="End Call" onClick={() => this.setState({ showEndCallConfirm: true })}>
                                        <i className="fa-solid fa-phone call-icon"></i>
                                    </div>
                                    {/* <div className="cuatomer-call-circle mx-3 p-relative OnHandleIcon chatTooltip" id="chat-icon" onClick={(e) => this.handleChat(e, checkIsConnected)}>
                                        {unreadMessageCount > 0 && <div className="chat-count">{unreadMessageCount}</div>}
                                        <i className='fa-solid fa-comment-dots chat-icon1'></i>
                                        <Tooltip anchorSelect=".chatTooltip" place="top">
                                            Chat
                                        </Tooltip>
                                    </div> */}
                                    {/* {(!isCustomer && virtualBackgroundImages?.length > 0) && <div className={`mx-3 p-relative OnHandleIcon virtualBackgroundTooltip ${isVirtualBackground ? "cuatomer-call-circle-slash" : "cuatomer-call-circle"} `} id="chat-icon" onClick={(e) => this.handleBackground(e, checkIsConnected)}>
                                        <i className={`fa-solid fa-chalkboard chat-icon1 ${isVirtualBackground ? "onScreenShareIcon" : ""}`}></i>
                                        <Tooltip anchorSelect=".virtualBackgroundTooltip" place="top">
                                            Virtual Background
                                        </Tooltip>
                                    </div>} */}
                                    {cartGeneration == 1 &&
                                        <>
                                            {!isCustomer && <div className="cuatomer-call-circle mx-3 OnOpenApp shopptingTooltip" id="chat-icon">
                                                <i className="fa fa-cart-plus  mic-icon" onClick={() => this.openApp()}></i>
                                                <Tooltip anchorSelect=".shopptingTooltip" place="top">
                                                    Shopping
                                                </Tooltip>
                                            </div>}
                                            {(!isCustomer && !isMobileDevice) &&
                                                <div className={`${!isScreenShared ? 'cuatomer-call-circle screenShareTooltip' : 'cuatomer-call-circle-slash'} mx-3 OnScreenStart`} id="chat-icon" onClick={() => isScreenShared ? this.onStopScreenShare() : this.onStartScreenShare()}>
                                                    <i className={`${isScreenShared && 'onScreenShareIcon'} fa-solid fa-arrow-up-from-bracket chat-icon1`}></i>
                                                    <Tooltip anchorSelect=".screenShareTooltip" place="top">
                                                        {
                                                            isScreenShared ? "Stop Screen Share" : "  Screen Share"
                                                        }
                                                    </Tooltip>
                                                </div>}
                                            {(!isCustomer) &&
                                                <div className="capture_icon">
                                                    <div className={`${!isCaptureButton ? 'cuatomer-call-circle ' : 'cuatomer-call-circle-slash '} mx-3 OnScreenStart`} id="chat-icon"
                                                        onClick={() => isCaptureButton ? this.onCaptureButtonClose() : this.onCaptureButtonOpen()}>
                                                        {!isCaptureButton ?
                                                            <>
                                                                <i className={`fa-solid fa-camera chat-icon1 captureTooltip`}></i>
                                                                <Tooltip anchorSelect=".captureTooltip" place="top">
                                                                    Capture
                                                                </Tooltip>
                                                            </>
                                                            :
                                                            <>
                                                                <i className={`${isCaptureButton && 'onScreenShareIcon captureCloseTooltip'} fa-solid fa-x chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".captureCloseTooltip" place="top">
                                                                    Close
                                                                </Tooltip>
                                                            </>
                                                        }
                                                    </div>

                                                    {isCaptureButton &&
                                                        <div className="capture_open_icon">
                                                            <div className={`cuatomer-call-circle mx-3 OnScreenStart retakeTooltip`} id="chat-icon" onClick={() => this.repeatPicture()}>
                                                                <i className={`fa-solid fa-repeat chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".retakeTooltip" place="top">
                                                                    Retake
                                                                </Tooltip>
                                                            </div>
                                                            <div className={`cuatomer-call-circle mx-3 OnScreenStart submitTooltip`} id="chat-icon" onClick={() => this.ageVerification()}>
                                                                <i className={`fa-solid fa-check chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".submitTooltip" place="top">
                                                                    Submit
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                                {(isScreenShared || isScreenView) && <ScreenShare share={isScreenShared} view={isScreenView} roomId={screenRoomId} onScreenShared={(d) => this.onScreenShared(d)} onStopScreenShare={this.onStopScreenShare} />}
                            </div>
                            <div className="mx-3">
                                {(!isCustomer) &&
                                    <>
                                        <canvas id="canvas"> </canvas>
                                        <div className="scan-box" id="capture-img"></div>
                                    </>}
                            </div>
                        </div>
                        {isChatOpened && <div className="col-12 col-lg-3 p-0" style={{ borderRadius: 0, zIndex: 111 }}>
                            <div className="card chat-card" id="chart-page">
                                <div className="card-header heading-part">
                                    <div className="d-flex head-content">
                                        <div className="chat-left">
                                            <i className="fa-solid fa-comment-dots chat-icon"></i>
                                            <p className="chat-text">{Constants.CHAT}</p>
                                        </div>
                                        <i className="fa-solid fa-close close-icon" id="close-query" onClick={() => this.setState({ isChatOpened: false })}></i>
                                    </div>
                                </div>
                                <div className="card-body chat-body-content">
                                    {Array.isArray(chatList) && chatList?.map((message, i) => {
                                        return (<div className="message-content" key={i}>
                                            <div className={`message-content-box 
                                             ${this.props.isCustomer ?
                                                    message.messageType === 4 ? 'me' : ''
                                                    : message.messageType === 3 ? 'me' : ''
                                                }`}>
                                                <div className="message-text">
                                                    {(message?.message?.includes(`https://${SHOPPING_DOMAIN}/customercare/payment`) ||
                                                        message?.message?.includes("paulsfashion.myshopify")) ? <div>
                                                        <QRCode
                                                            value={message.message}
                                                        /><br />
                                                        {isCustomer && <span style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => this.openLink(message.message)}>{Constants.PAY_NOW}</span>}
                                                    </div> : message.message}
                                                </div>
                                            </div>
                                        </div>)
                                    })}
                                </div>
                                <div className="card-footer chat-footer">
                                    <div className="input-content">
                                        <input autoComplete="off" type="text" className="form-control type-message" placeholder="Type a message"
                                            value={message} name="message" onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.handleKeyUp(e)} />
                                    </div>
                                    <i className="fas fa-paper-plane send-icon" onClick={() => this.sendMessage()}></i>
                                </div>
                            </div>
                        </div>}
                        {isVrBackgroundIcon && <div className="col-12 col-lg-3 p-0" style={{ borderRadius: 0, zIndex: 111 }}>
                            <div className="card chat-card" id="chart-page">
                                <div className="card-header heading-part">
                                    <div className="d-flex head-content">
                                        <div className="chat-left">
                                            <i className="fa-solid fa-chalkboard chat-icon"></i>
                                            <p className="chat-text">Virtual Background</p>
                                        </div>
                                        <i className="fa-solid fa-close close-icon" id="close-query" onClick={() => this.setState({ isVrBackgroundIcon: false })}></i>
                                    </div>
                                </div>
                                <div className="card-body chat-body-content">
                                    <p className="m-0">No effects</p>
                                    <div className="row m-0">
                                        <div className="col-6 px-2 py-2">
                                            <div className={`noeffect_box ${virtualBackgroundSelectId === 0 ? " bg_active" : ""}`}>
                                                <img id="vbackground_0" src={NoEffect} alt="No effect" width="30%" onClick={(e) => this.setVideo(e.target, 0, true)} />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="mb-0 mt-1">{virtualBackgroundImages.length > 1 ? "Backgrounds" : "Background"}</p>
                                    {virtualBackgroundImages.length > 1 && <div className="row m-0 mt-3">
                                        <div onClick={(e) => { this.changeVbOption(e) }}>
                                            View Options &nbsp; &nbsp;
                                            <input type="radio" value={vbOption} name="vbOption" checked={vbOption === 1 ? true : false} /> Static &nbsp;
                                            <input type="radio" value={vbOption} name="vbOption" checked={vbOption === 2 ? true : false} /> Loop &nbsp;
                                        </div>
                                    </div>}
                                    <div className="row m-0">
                                        {virtualBackgroundImages?.map((img, i) => {
                                            return <div className="col-6 px-2 py-2" key={i}>
                                                <div className={`bg_effect_align ${virtualBackgroundSelectId === img?.id ? " bg_active" : ""}`}>
                                                    <img id={`vbackground_${img?.id}`} src={img?.imageURL} alt="The Screen" onClick={(e) => this.autoChangeBackground(e.target, img?.id, i, virtualBackgroundImages)} />
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}
export const mapStateToProps = (state) => {
    return {
        getTokenDetails: state,
        getCustomerToken: state?.CUSTOMER_LIST?.customerList?.response?.User,
        getChatListAction: state?.CHAT_LIST?.currentArrayList,
        getQueueList: state?.CHAT_LIST,
        isCallAttended: state?.FEEDBACK?.isAttended,
        attenedName: Actions.getLoginDetails(state),
        callerName: Actions.getCustomerCallListDetails(state),
        appointmentDetails: state?.UPDATE_APPOINTMENT?.updateAppointment?.response,
        customerDeclineLoader: state?.CUSTOMER_DECLINE,
        chatListLoader: state?.CHAT_LIST,
        updateAppointmentLoader: state?.UPDATE_APPOINTMENT,
        currentServices: state.CUSTOMER_LIST?.srmIpRoomService?.response
    }
};
export default withRouter(connect(mapStateToProps, {
    customerDeclineAction: Actions.customerDeclineAction,
    updateAppointment: Actions.updateAppointmentAction,
    chatListAction: Actions.chatListAction,
    virtualBackgroundListAction: Actions.getAgentVbImageList,
    addChatListAction: Actions.addChatListAction,
    appendChat: Actions.appendChatAction,
    socketAppendChatAction: Actions.socketAppendChatAction,
    appendQueueList: Actions.addChatQueueList,
    screenShareAction: Actions.screenShareAction,
    updateScreenShareAction: Actions.updateScreenShareAction,
    ageVerification: Actions.getAgeVerificationAction,
    vbImage: Actions.getVirtualBackgroundAction,
    customerListAction: Actions.cutomerListAction,
})(Verification))